// CommonJS package manager support
if (typeof module !== 'undefined' && typeof exports !== 'undefined' &&
  module.exports === exports) {
  // Export the *name* of this Angular module
  // Sample usage:
  //
  //   import lbServices from './lb-services';
  //   angular.module('app', [lbServices]);
  //
  module.exports = "lbServices";
}

(function(window, angular, undefined) {
  'use strict';

  var urlBase = "/api";
  var authHeader = 'authorization';

  function getHost(url) {
    var m = url.match(/^(?:https?:)?\/\/([^\/]+)/);
    return m ? m[1] : null;
  }

  var urlBaseHost = getHost(urlBase) || location.host;

/**
 * @ngdoc overview
 * @name lbServices
 * @module
 * @description
 *
 * The `lbServices` module provides services for interacting with
 * the models exposed by the LoopBack server via the REST API.
 *
 */
  var module = angular.module("lbServices", ['ngResource']);

/**
 * @ngdoc object
 * @name lbServices.AccessToken
 * @header lbServices.AccessToken
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `AccessToken` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "AccessToken",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/AccessTokens/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use AccessToken.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/AccessTokens/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#create
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/AccessTokens",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#createMany
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/AccessTokens",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#upsert
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/AccessTokens",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#replaceOrCreate
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/AccessTokens/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#upsertWithWhere
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/AccessTokens/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#exists
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/AccessTokens/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#findById
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/AccessTokens/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#replaceById
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/AccessTokens/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#find
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/AccessTokens",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#findOne
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/AccessTokens/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#updateAll
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/AccessTokens/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#deleteById
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/AccessTokens/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#count
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/AccessTokens/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#prototype$updateAttributes
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccessToken id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/AccessTokens/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#createChangeStream
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/AccessTokens/change-stream",
              method: "POST",
            },

            // INTERNAL. Use User.accessTokens() instead.
            "::get::User::accessTokens": {
              isArray: true,
              url: urlBase + "/users/:id/accessTokens",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.AccessToken#patchOrCreate
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#updateOrCreate
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#patchOrCreateWithWhere
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#update
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#destroyById
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#removeById
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.AccessToken#patchAttributes
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccessToken id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.AccessToken#modelName
        * @propertyOf lbServices.AccessToken
        * @description
        * The name of the model represented by this $resource,
        * i.e. `AccessToken`.
        */
        R.modelName = "AccessToken";


            /**
             * @ngdoc method
             * @name lbServices.AccessToken#user
             * @methodOf lbServices.AccessToken
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccessToken id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::AccessToken::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Storage
 * @header lbServices.Storage
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Storage` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Storage",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/storages/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Storage#upload
             * @methodOf lbServices.Storage
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "upload": {
              url: urlBase + "/storages/:container/upload",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Storage#modelName
        * @propertyOf lbServices.Storage
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Storage`.
        */
        R.modelName = "Storage";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PrivateStorage
 * @header lbServices.PrivateStorage
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PrivateStorage` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PrivateStorage",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/privateStorages/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.PrivateStorage#getContainers
             * @methodOf lbServices.PrivateStorage
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PrivateStorage` object.)
             * </em>
             */
            "getContainers": {
              isArray: true,
              url: urlBase + "/privateStorages",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PrivateStorage#createContainer
             * @methodOf lbServices.PrivateStorage
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PrivateStorage` object.)
             * </em>
             */
            "createContainer": {
              url: urlBase + "/privateStorages",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PrivateStorage#destroyContainer
             * @methodOf lbServices.PrivateStorage
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "destroyContainer": {
              url: urlBase + "/privateStorages/:container",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PrivateStorage#getContainer
             * @methodOf lbServices.PrivateStorage
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PrivateStorage` object.)
             * </em>
             */
            "getContainer": {
              url: urlBase + "/privateStorages/:container",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PrivateStorage#getFiles
             * @methodOf lbServices.PrivateStorage
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PrivateStorage` object.)
             * </em>
             */
            "getFiles": {
              isArray: true,
              url: urlBase + "/privateStorages/:container/files",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PrivateStorage#getFile
             * @methodOf lbServices.PrivateStorage
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             *  - `file` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PrivateStorage` object.)
             * </em>
             */
            "getFile": {
              url: urlBase + "/privateStorages/:container/files/:file",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PrivateStorage#removeFile
             * @methodOf lbServices.PrivateStorage
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             *  - `file` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "removeFile": {
              url: urlBase + "/privateStorages/:container/files/:file",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PrivateStorage#upload
             * @methodOf lbServices.PrivateStorage
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "upload": {
              url: urlBase + "/privateStorages/:container/upload",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PrivateStorage#download
             * @methodOf lbServices.PrivateStorage
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             *  - `file` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "download": {
              url: urlBase + "/privateStorages/:container/download/:file",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PrivateStorage#uploadFile
             * @methodOf lbServices.PrivateStorage
             *
             * @description
             *
             * Uploads a file
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `temporary` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PrivateStorage` object.)
             * </em>
             */
            "uploadFile": {
              url: urlBase + "/privateStorages/uploadFile",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.PrivateStorage#modelName
        * @propertyOf lbServices.PrivateStorage
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PrivateStorage`.
        */
        R.modelName = "PrivateStorage";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Document
 * @header lbServices.Document
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Document` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Document",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/documents/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Document#create
             * @methodOf lbServices.Document
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/documents",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Document#createMany
             * @methodOf lbServices.Document
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/documents",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Document#replaceOrCreate
             * @methodOf lbServices.Document
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/documents/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Document#upsertWithWhere
             * @methodOf lbServices.Document
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/documents/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Document#findById
             * @methodOf lbServices.Document
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/documents/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Document#replaceById
             * @methodOf lbServices.Document
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/documents/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Document#find
             * @methodOf lbServices.Document
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/documents",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Document#deleteById
             * @methodOf lbServices.Document
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/documents/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Document#prototype$updateAttributes
             * @methodOf lbServices.Document
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - document id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/documents/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Document#prototype$temporaryUrl
             * @methodOf lbServices.Document
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - document id
             *
             *  - `options` – `{object=}` -
             *
             *  - `download` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `url` – `{string=}` -
             */
            "prototype$temporaryUrl": {
              url: urlBase + "/documents/:id/temporaryUrl",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Document#prototype$finalizePagesTeleconsent
             * @methodOf lbServices.Document
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - document id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `html` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `url` – `{string=}` -
             */
            "prototype$finalizePagesTeleconsent": {
              url: urlBase + "/documents/:id/finalizePagesTeleconsent",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Document#defaultTeleconsents
             * @methodOf lbServices.Document
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
            "defaultTeleconsents": {
              isArray: true,
              url: urlBase + "/documents/defaultTeleconsents",
              method: "GET",
            },

            // INTERNAL. Use Institution.documents.findById() instead.
            "::findById::Institution::documents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/institutions/:id/documents/:fk",
              method: "GET",
            },

            // INTERNAL. Use Institution.documents.updateById() instead.
            "::updateById::Institution::documents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/institutions/:id/documents/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Institution.documents() instead.
            "::get::Institution::documents": {
              isArray: true,
              url: urlBase + "/institutions/:id/documents",
              method: "GET",
            },

            // INTERNAL. Use Institution.documents.create() instead.
            "::create::Institution::documents": {
              url: urlBase + "/institutions/:id/documents",
              method: "POST",
            },

            // INTERNAL. Use Institution.documents.createMany() instead.
            "::createMany::Institution::documents": {
              isArray: true,
              url: urlBase + "/institutions/:id/documents",
              method: "POST",
            },

            // INTERNAL. Use User.documents.findById() instead.
            "::findById::User::documents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/documents/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.documents.destroyById() instead.
            "::destroyById::User::documents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/documents/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.documents.updateById() instead.
            "::updateById::User::documents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/documents/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.documents() instead.
            "::get::User::documents": {
              isArray: true,
              url: urlBase + "/users/:id/documents",
              method: "GET",
            },

            // INTERNAL. Use User.documents.create() instead.
            "::create::User::documents": {
              url: urlBase + "/users/:id/documents",
              method: "POST",
            },

            // INTERNAL. Use User.documents.createMany() instead.
            "::createMany::User::documents": {
              isArray: true,
              url: urlBase + "/users/:id/documents",
              method: "POST",
            },

            // INTERNAL. Use TeleconsentDocument.document() instead.
            "::get::TeleconsentDocument::document": {
              url: urlBase + "/teleconsentDocuments/:id/document",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Document#patchOrCreateWithWhere
             * @methodOf lbServices.Document
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Document#destroyById
             * @methodOf lbServices.Document
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Document#removeById
             * @methodOf lbServices.Document
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Document#patchAttributes
             * @methodOf lbServices.Document
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - document id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Document#modelName
        * @propertyOf lbServices.Document
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Document`.
        */
        R.modelName = "Document";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Institution
 * @header lbServices.Institution
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Institution` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Institution",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/institutions/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Institution.documents.findById() instead.
            "prototype$__findById__documents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/institutions/:id/documents/:fk",
              method: "GET",
            },

            // INTERNAL. Use Institution.documents.updateById() instead.
            "prototype$__updateById__documents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/institutions/:id/documents/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Institution.rooms.findById() instead.
            "prototype$__findById__rooms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/institutions/:id/rooms/:fk",
              method: "GET",
            },

            // INTERNAL. Use Institution.inviteTokens.findById() instead.
            "prototype$__findById__inviteTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/institutions/:id/inviteTokens/:fk",
              method: "GET",
            },

            // INTERNAL. Use Institution.inviteTokens.destroyById() instead.
            "prototype$__destroyById__inviteTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/institutions/:id/inviteTokens/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Institution.users.link() instead.
            "prototype$__link__users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/institutions/:id/users/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Institution.users.unlink() instead.
            "prototype$__unlink__users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/institutions/:id/users/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Institution.institutionMemberships.updateById() instead.
            "prototype$__updateById__institutionMemberships": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/institutions/:id/institutionMemberships/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Institution.purchases.findById() instead.
            "prototype$__findById__purchases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/institutions/:id/purchases/:fk",
              method: "GET",
            },

            // INTERNAL. Use Institution.settings() instead.
            "prototype$__get__settings": {
              url: urlBase + "/institutions/:id/settings",
              method: "GET",
            },

            // INTERNAL. Use Institution.settings.create() instead.
            "prototype$__create__settings": {
              url: urlBase + "/institutions/:id/settings",
              method: "POST",
            },

            // INTERNAL. Use Institution.settings.update() instead.
            "prototype$__update__settings": {
              url: urlBase + "/institutions/:id/settings",
              method: "PUT",
            },

            // INTERNAL. Use Institution.settings.destroy() instead.
            "prototype$__destroy__settings": {
              url: urlBase + "/institutions/:id/settings",
              method: "DELETE",
            },

            // INTERNAL. Use Institution.institutionAccess() instead.
            "prototype$__get__institutionAccess": {
              url: urlBase + "/institutions/:id/institutionAccess",
              method: "GET",
            },

            // INTERNAL. Use Institution.institutionAccess.create() instead.
            "prototype$__create__institutionAccess": {
              url: urlBase + "/institutions/:id/institutionAccess",
              method: "POST",
            },

            // INTERNAL. Use Institution.institutionAccess.update() instead.
            "prototype$__update__institutionAccess": {
              url: urlBase + "/institutions/:id/institutionAccess",
              method: "PUT",
            },

            // INTERNAL. Use Institution.institutionAccess.destroy() instead.
            "prototype$__destroy__institutionAccess": {
              url: urlBase + "/institutions/:id/institutionAccess",
              method: "DELETE",
            },

            // INTERNAL. Use Institution.documents() instead.
            "prototype$__get__documents": {
              isArray: true,
              url: urlBase + "/institutions/:id/documents",
              method: "GET",
            },

            // INTERNAL. Use Institution.documents.create() instead.
            "prototype$__create__documents": {
              url: urlBase + "/institutions/:id/documents",
              method: "POST",
            },

            // INTERNAL. Use Institution.rooms() instead.
            "prototype$__get__rooms": {
              isArray: true,
              url: urlBase + "/institutions/:id/rooms",
              method: "GET",
            },

            // INTERNAL. Use Institution.rooms.count() instead.
            "prototype$__count__rooms": {
              url: urlBase + "/institutions/:id/rooms/count",
              method: "GET",
            },

            // INTERNAL. Use Institution.inviteTokens() instead.
            "prototype$__get__inviteTokens": {
              isArray: true,
              url: urlBase + "/institutions/:id/inviteTokens",
              method: "GET",
            },

            // INTERNAL. Use Institution.inviteTokens.create() instead.
            "prototype$__create__inviteTokens": {
              url: urlBase + "/institutions/:id/inviteTokens",
              method: "POST",
            },

            // INTERNAL. Use Institution.users() instead.
            "prototype$__get__users": {
              isArray: true,
              url: urlBase + "/institutions/:id/users",
              method: "GET",
            },

            // INTERNAL. Use Institution.institutionMemberships() instead.
            "prototype$__get__institutionMemberships": {
              isArray: true,
              url: urlBase + "/institutions/:id/institutionMemberships",
              method: "GET",
            },

            // INTERNAL. Use Institution.purchases() instead.
            "prototype$__get__purchases": {
              isArray: true,
              url: urlBase + "/institutions/:id/purchases",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#create
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/institutions",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#createMany
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/institutions",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#upsert
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/institutions",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#replaceOrCreate
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/institutions/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#upsertWithWhere
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/institutions/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#findById
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/institutions/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#replaceById
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/institutions/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#find
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/institutions",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#findOne
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/institutions/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#deleteById
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/institutions/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#count
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/institutions/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#prototype$updateAttributes
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/institutions/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#hints
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `domain` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `hints` – `{*=}` -
             */
            "hints": {
              url: urlBase + "/institutions/hints",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#countRoomAccessUsers
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `id` – `{number}` -
             *
             *  - `query` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "countRoomAccessUsers": {
              url: urlBase + "/institutions/:id/countRoomAccessUsers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#getUsersForRoomAccess
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `id` – `{number}` -
             *
             *  - `query` – `{string=}` -
             *
             *  - `limit` – `{number=}` -
             *
             *  - `offset` – `{number=}` -
             *
             *  - `sortBy` – `{string=}` -
             *
             *  - `isDesc` – `{boolean=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "getUsersForRoomAccess": {
              isArray: true,
              url: urlBase + "/institutions/:id/getUsersForRoomAccess",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#getUsers
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `id` – `{number}` -
             *
             *  - `query` – `{string=}` -
             *
             *  - `limit` – `{number=}` -
             *
             *  - `offset` – `{number=}` -
             *
             *  - `sortBy` – `{string=}` -
             *
             *  - `isDesc` – `{boolean=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "getUsers": {
              isArray: true,
              url: urlBase + "/institutions/:id/manageUsers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#prototype$getUsersCount
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `id` – `{number}` -
             *
             *  - `query` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "prototype$getUsersCount": {
              url: urlBase + "/institutions/:id/manageUsers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#migrate
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method does not accept any data. Supply an empty object.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "migrate": {
              url: urlBase + "/institutions/migrate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#prototype$sendInviteNotification
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `tokenId` – `{string}` -
             *
             *  - `req` – `{undefined=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "prototype$sendInviteNotification": {
              url: urlBase + "/institutions/:id/sendInviteNotification",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#getSharedRoomsForClinicSettings
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `id` – `{number}` -
             *
             *  - `query` – `{string=}` -
             *
             *  - `limit` – `{number=}` -
             *
             *  - `offset` – `{number=}` -
             *
             *  - `sortBy` – `{string=}` -
             *
             *  - `isDesc` – `{boolean=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "getSharedRoomsForClinicSettings": {
              isArray: true,
              url: urlBase + "/institutions/:id/getSharedRoomsForClinicSettings",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#getSharedRoomsForClinicSettingsCount
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `id` – `{number}` -
             *
             *  - `query` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "getSharedRoomsForClinicSettingsCount": {
              url: urlBase + "/institutions/:id/getSharedRoomsForClinicSettings/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#prototype$rememberAuthState
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `res` – `{undefined=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "prototype$rememberAuthState": {
              url: urlBase + "/institutions/:id/rememberAuthState",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#prototype$checkAuthState
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `res` – `{undefined=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "prototype$checkAuthState": {
              url: urlBase + "/institutions/:id/checkAuthState",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#prototype$addUsersBatch
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `userData` – `{*}` -
             *
             *  - `req` – `{undefined=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "prototype$addUsersBatch": {
              url: urlBase + "/institutions/:id/addUsersBatch",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#prototype$resendInvite
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `tokenId` – `{string}` -
             *
             *  - `req` – `{undefined=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "prototype$resendInvite": {
              url: urlBase + "/institutions/:id/resendInvite",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#prototype$updatePublicAttributes
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `attributes` – `{object=}` -
             *
             *  - `institutionAccess` – `{object=}` -
             *
             *  - `req` – `{undefined=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "prototype$updatePublicAttributes": {
              url: urlBase + "/institutions/:id/updatePublicAttributes",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#prototype$updateUserRolesBatch
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `memberships` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "prototype$updateUserRolesBatch": {
              url: urlBase + "/institutions/:id/updateUserRolesBatch",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#prototype$loginAsMember
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `userId` – `{string}` -
             *
             *  - `req` – `{undefined=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "prototype$loginAsMember": {
              url: urlBase + "/institutions/:id/loginAsMember",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#prototype$restoreDefaultRoomsWidgets
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `roomId` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "prototype$restoreDefaultRoomsWidgets": {
              url: urlBase + "/institutions/:id/restoreDefaultRoomsWidgets",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#prototype$updateRoomsWidgets
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `roomId` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "prototype$updateRoomsWidgets": {
              url: urlBase + "/institutions/:id/updateRoomsWidgets",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#prototype$getSharedRooms
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             *  - `req` – `{undefined=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "prototype$getSharedRooms": {
              isArray: true,
              url: urlBase + "/institutions/:id/getSharedRooms",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#prototype$exportUserList
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "prototype$exportUserList": {
              isArray: true,
              url: urlBase + "/institutions/:id/exportUserList",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#prototype$getAnalyticsFilterOptions
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             *  - `req` – `{undefined=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "prototype$getAnalyticsFilterOptions": {
              url: urlBase + "/institutions/:id/getAnalyticsFilterOptions",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#uniqueEmailForInstitution
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `email` – `{string}` -
             *
             *  - `institutionId` – `{number}` -
             *
             *  - `isPending` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "uniqueEmailForInstitution": {
              url: urlBase + "/institutions/uniqueEmailForInstitution",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#getRoomsForLandingPage
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `institutionId` – `{number}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "getRoomsForLandingPage": {
              isArray: true,
              url: urlBase + "/institutions/getRoomsForLandingPage/:institutionId",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#prototype$hasInstitutionOwnerStripeConnect
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `hasStripeConnect` – `{boolean=}` -
             */
            "prototype$hasInstitutionOwnerStripeConnect": {
              url: urlBase + "/institutions/:id/hasInstitutionOwnerStripeConnect",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#findInstitutionCount
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `query` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "findInstitutionCount": {
              url: urlBase + "/institutions/findInstitutionCount",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#findInstitution
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `query` – `{string}` -
             *
             *  - `limit` – `{number=}` -
             *
             *  - `offset` – `{number=}` -
             *
             *  - `sortBy` – `{string=}` -
             *
             *  - `isDesc` – `{boolean=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "findInstitution": {
              isArray: true,
              url: urlBase + "/institutions/findInstitution",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#findRooms
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `institutionId` – `{number}` -
             *
             *  - `searchValue` – `{string=}` -
             *
             *  - `limit` – `{number=}` -
             *
             *  - `offset` – `{number=}` -
             *
             *  - `sortBy` – `{string=}` -
             *
             *  - `isDesc` – `{boolean=}` -
             *
             *  - `isPersonal` – `{boolean=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "findRooms": {
              isArray: true,
              url: urlBase + "/institutions/:institutionId/findRooms",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#findRoomsCount
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `institutionId` – `{number}` -
             *
             *  - `searchValue` – `{string=}` -
             *
             *  - `isPersonal` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "findRoomsCount": {
              url: urlBase + "/institutions/:institutionId/findRooms/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Institution#prototype$updateRedirect
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `shouldRedirect` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
            "prototype$updateRedirect": {
              url: urlBase + "/institutions/:id/updateRedirect",
              method: "POST",
            },

            // INTERNAL. Use User.institutions.findById() instead.
            "::findById::User::institutions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/institutions/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.institutions.updateById() instead.
            "::updateById::User::institutions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/institutions/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.institutions.link() instead.
            "::link::User::institutions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/institutions/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.institutions.unlink() instead.
            "::unlink::User::institutions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/institutions/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.institutions() instead.
            "::get::User::institutions": {
              isArray: true,
              url: urlBase + "/users/:id/institutions",
              method: "GET",
            },

            // INTERNAL. Use Purchase.institution() instead.
            "::get::Purchase::institution": {
              url: urlBase + "/purchases/:id/institution",
              method: "GET",
            },

            // INTERNAL. Use InstitutionSettings.institution() instead.
            "::get::InstitutionSettings::institution": {
              url: urlBase + "/institutionSettings/:id/institution",
              method: "GET",
            },

            // INTERNAL. Use InstitutionAccess.institution() instead.
            "::get::InstitutionAccess::institution": {
              url: urlBase + "/institutionAccesses/:id/institution",
              method: "GET",
            },

            // INTERNAL. Use DokbotWorkflow.institution() instead.
            "::get::DokbotWorkflow::institution": {
              url: urlBase + "/dokbotWorkflow/:id/institution",
              method: "GET",
            },

            // INTERNAL. Use InstitutionLocation.institution() instead.
            "::get::InstitutionLocation::institution": {
              url: urlBase + "/institutionLocation/:id/institution",
              method: "GET",
            },

            // INTERNAL. Use TeleconsentDocument.institution() instead.
            "::get::TeleconsentDocument::institution": {
              url: urlBase + "/teleconsentDocuments/:id/institution",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Institution#patchOrCreate
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Institution#updateOrCreate
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Institution#patchOrCreateWithWhere
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Institution#destroyById
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Institution#removeById
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Institution#patchAttributes
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Institution#modelName
        * @propertyOf lbServices.Institution
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Institution`.
        */
        R.modelName = "Institution";

    /**
     * @ngdoc object
     * @name lbServices.Institution.documents
     * @header lbServices.Institution.documents
     * @object
     * @description
     *
     * The object `Institution.documents` groups methods
     * manipulating `Document` instances related to `Institution`.
     *
     * Call {@link lbServices.Institution#documents Institution.documents()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Institution#documents
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Queries documents of institution.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
        R.documents = function() {
          var TargetResource = $injector.get("Document");
          var action = TargetResource["::get::Institution::documents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Institution.documents#create
             * @methodOf lbServices.Institution.documents
             *
             * @description
             *
             * Creates a new instance in documents of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
        R.documents.create = function() {
          var TargetResource = $injector.get("Document");
          var action = TargetResource["::create::Institution::documents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Institution.documents#createMany
             * @methodOf lbServices.Institution.documents
             *
             * @description
             *
             * Creates a new instance in documents of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
        R.documents.createMany = function() {
          var TargetResource = $injector.get("Document");
          var action = TargetResource["::createMany::Institution::documents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Institution.documents#findById
             * @methodOf lbServices.Institution.documents
             *
             * @description
             *
             * Find a related item by id for documents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for documents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
        R.documents.findById = function() {
          var TargetResource = $injector.get("Document");
          var action = TargetResource["::findById::Institution::documents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Institution.documents#updateById
             * @methodOf lbServices.Institution.documents
             *
             * @description
             *
             * Update a related item by id for documents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `fk` – `{*}` - Foreign key for documents
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
        R.documents.updateById = function() {
          var TargetResource = $injector.get("Document");
          var action = TargetResource["::updateById::Institution::documents"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Institution.rooms
     * @header lbServices.Institution.rooms
     * @object
     * @description
     *
     * The object `Institution.rooms` groups methods
     * manipulating `Room` instances related to `Institution`.
     *
     * Call {@link lbServices.Institution#rooms Institution.rooms()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Institution#rooms
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Queries rooms of institution.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
        R.rooms = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::get::Institution::rooms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Institution.rooms#count
             * @methodOf lbServices.Institution.rooms
             *
             * @description
             *
             * Counts rooms of institution.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.rooms.count = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::count::Institution::rooms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Institution.rooms#findById
             * @methodOf lbServices.Institution.rooms
             *
             * @description
             *
             * Find a related item by id for rooms.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for rooms
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
        R.rooms.findById = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::findById::Institution::rooms"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Institution.inviteTokens
     * @header lbServices.Institution.inviteTokens
     * @object
     * @description
     *
     * The object `Institution.inviteTokens` groups methods
     * manipulating `InviteToken` instances related to `Institution`.
     *
     * Call {@link lbServices.Institution#inviteTokens Institution.inviteTokens()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Institution#inviteTokens
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Queries inviteTokens of institution.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InviteToken` object.)
             * </em>
             */
        R.inviteTokens = function() {
          var TargetResource = $injector.get("InviteToken");
          var action = TargetResource["::get::Institution::inviteTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Institution.inviteTokens#create
             * @methodOf lbServices.Institution.inviteTokens
             *
             * @description
             *
             * Creates a new instance in inviteTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InviteToken` object.)
             * </em>
             */
        R.inviteTokens.create = function() {
          var TargetResource = $injector.get("InviteToken");
          var action = TargetResource["::create::Institution::inviteTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Institution.inviteTokens#createMany
             * @methodOf lbServices.Institution.inviteTokens
             *
             * @description
             *
             * Creates a new instance in inviteTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InviteToken` object.)
             * </em>
             */
        R.inviteTokens.createMany = function() {
          var TargetResource = $injector.get("InviteToken");
          var action = TargetResource["::createMany::Institution::inviteTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Institution.inviteTokens#destroyById
             * @methodOf lbServices.Institution.inviteTokens
             *
             * @description
             *
             * Delete a related item by id for inviteTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for inviteTokens
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.inviteTokens.destroyById = function() {
          var TargetResource = $injector.get("InviteToken");
          var action = TargetResource["::destroyById::Institution::inviteTokens"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Institution.inviteTokens#findById
             * @methodOf lbServices.Institution.inviteTokens
             *
             * @description
             *
             * Find a related item by id for inviteTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for inviteTokens
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InviteToken` object.)
             * </em>
             */
        R.inviteTokens.findById = function() {
          var TargetResource = $injector.get("InviteToken");
          var action = TargetResource["::findById::Institution::inviteTokens"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Institution.users
     * @header lbServices.Institution.users
     * @object
     * @description
     *
     * The object `Institution.users` groups methods
     * manipulating `User` instances related to `Institution`.
     *
     * Call {@link lbServices.Institution#users Institution.users()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Institution#users
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Queries users of institution.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.users = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Institution::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Institution.users#link
             * @methodOf lbServices.Institution.users
             *
             * @description
             *
             * Add a related item by id for users.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `fk` – `{*}` - Foreign key for users
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.users.link = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::link::Institution::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Institution.users#unlink
             * @methodOf lbServices.Institution.users
             *
             * @description
             *
             * Remove the users relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for users
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.users.unlink = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::unlink::Institution::users"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Institution.institutionMemberships
     * @header lbServices.Institution.institutionMemberships
     * @object
     * @description
     *
     * The object `Institution.institutionMemberships` groups methods
     * manipulating `InstitutionMember` instances related to `Institution`.
     *
     * Call {@link lbServices.Institution#institutionMemberships Institution.institutionMemberships()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Institution#institutionMemberships
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Queries institutionMemberships of institution.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionMember` object.)
             * </em>
             */
        R.institutionMemberships = function() {
          var TargetResource = $injector.get("InstitutionMember");
          var action = TargetResource["::get::Institution::institutionMemberships"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Institution.institutionMemberships#updateById
             * @methodOf lbServices.Institution.institutionMemberships
             *
             * @description
             *
             * Update a related item by id for institutionMemberships.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `fk` – `{*}` - Foreign key for institutionMemberships
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionMember` object.)
             * </em>
             */
        R.institutionMemberships.updateById = function() {
          var TargetResource = $injector.get("InstitutionMember");
          var action = TargetResource["::updateById::Institution::institutionMemberships"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Institution.purchases
     * @header lbServices.Institution.purchases
     * @object
     * @description
     *
     * The object `Institution.purchases` groups methods
     * manipulating `Purchase` instances related to `Institution`.
     *
     * Call {@link lbServices.Institution#purchases Institution.purchases()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Institution#purchases
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Queries purchases of institution.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
        R.purchases = function() {
          var TargetResource = $injector.get("Purchase");
          var action = TargetResource["::get::Institution::purchases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Institution.purchases#findById
             * @methodOf lbServices.Institution.purchases
             *
             * @description
             *
             * Find a related item by id for purchases.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for purchases
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
        R.purchases.findById = function() {
          var TargetResource = $injector.get("Purchase");
          var action = TargetResource["::findById::Institution::purchases"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Institution.settings
     * @header lbServices.Institution.settings
     * @object
     * @description
     *
     * The object `Institution.settings` groups methods
     * manipulating `InstitutionSettings` instances related to `Institution`.
     *
     * Call {@link lbServices.Institution#settings Institution.settings()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Institution#settings
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Fetches hasOne relation settings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionSettings` object.)
             * </em>
             */
        R.settings = function() {
          var TargetResource = $injector.get("InstitutionSettings");
          var action = TargetResource["::get::Institution::settings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Institution.settings#create
             * @methodOf lbServices.Institution.settings
             *
             * @description
             *
             * Creates a new instance in settings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionSettings` object.)
             * </em>
             */
        R.settings.create = function() {
          var TargetResource = $injector.get("InstitutionSettings");
          var action = TargetResource["::create::Institution::settings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Institution.settings#createMany
             * @methodOf lbServices.Institution.settings
             *
             * @description
             *
             * Creates a new instance in settings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionSettings` object.)
             * </em>
             */
        R.settings.createMany = function() {
          var TargetResource = $injector.get("InstitutionSettings");
          var action = TargetResource["::createMany::Institution::settings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Institution.settings#destroy
             * @methodOf lbServices.Institution.settings
             *
             * @description
             *
             * Deletes settings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.settings.destroy = function() {
          var TargetResource = $injector.get("InstitutionSettings");
          var action = TargetResource["::destroy::Institution::settings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Institution.settings#update
             * @methodOf lbServices.Institution.settings
             *
             * @description
             *
             * Update settings of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionSettings` object.)
             * </em>
             */
        R.settings.update = function() {
          var TargetResource = $injector.get("InstitutionSettings");
          var action = TargetResource["::update::Institution::settings"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Institution.institutionAccess
     * @header lbServices.Institution.institutionAccess
     * @object
     * @description
     *
     * The object `Institution.institutionAccess` groups methods
     * manipulating `InstitutionAccess` instances related to `Institution`.
     *
     * Call {@link lbServices.Institution#institutionAccess Institution.institutionAccess()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Institution#institutionAccess
             * @methodOf lbServices.Institution
             *
             * @description
             *
             * Fetches hasOne relation institutionAccess.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionAccess` object.)
             * </em>
             */
        R.institutionAccess = function() {
          var TargetResource = $injector.get("InstitutionAccess");
          var action = TargetResource["::get::Institution::institutionAccess"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Institution.institutionAccess#create
             * @methodOf lbServices.Institution.institutionAccess
             *
             * @description
             *
             * Creates a new instance in institutionAccess of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionAccess` object.)
             * </em>
             */
        R.institutionAccess.create = function() {
          var TargetResource = $injector.get("InstitutionAccess");
          var action = TargetResource["::create::Institution::institutionAccess"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Institution.institutionAccess#createMany
             * @methodOf lbServices.Institution.institutionAccess
             *
             * @description
             *
             * Creates a new instance in institutionAccess of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionAccess` object.)
             * </em>
             */
        R.institutionAccess.createMany = function() {
          var TargetResource = $injector.get("InstitutionAccess");
          var action = TargetResource["::createMany::Institution::institutionAccess"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Institution.institutionAccess#destroy
             * @methodOf lbServices.Institution.institutionAccess
             *
             * @description
             *
             * Deletes institutionAccess of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.institutionAccess.destroy = function() {
          var TargetResource = $injector.get("InstitutionAccess");
          var action = TargetResource["::destroy::Institution::institutionAccess"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Institution.institutionAccess#update
             * @methodOf lbServices.Institution.institutionAccess
             *
             * @description
             *
             * Update institutionAccess of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institution id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionAccess` object.)
             * </em>
             */
        R.institutionAccess.update = function() {
          var TargetResource = $injector.get("InstitutionAccess");
          var action = TargetResource["::update::Institution::institutionAccess"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Room
 * @header lbServices.Room
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Room` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Room",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/rooms/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Room.sessions.updateById() instead.
            "prototype$__updateById__sessions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/rooms/:id/sessions/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Room.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/rooms/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Room.users.findById() instead.
            "prototype$__findById__users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/rooms/:id/users/:fk",
              method: "GET",
            },

            // INTERNAL. Use Room.users.link() instead.
            "prototype$__link__users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/rooms/:id/users/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Room.users.unlink() instead.
            "prototype$__unlink__users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/rooms/:id/users/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Room.users.exists() instead.
            "prototype$__exists__users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/rooms/:id/users/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Room.roomMemberships.destroyById() instead.
            "prototype$__destroyById__roomMemberships": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/rooms/:id/roomMemberships/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Room.roomMemberships.updateById() instead.
            "prototype$__updateById__roomMemberships": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/rooms/:id/roomMemberships/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Room.sessions() instead.
            "prototype$__get__sessions": {
              isArray: true,
              url: urlBase + "/rooms/:id/sessions",
              method: "GET",
            },

            // INTERNAL. Use Room.sessions.create() instead.
            "prototype$__create__sessions": {
              url: urlBase + "/rooms/:id/sessions",
              method: "POST",
            },

            // INTERNAL. Use Room.sessions.count() instead.
            "prototype$__count__sessions": {
              url: urlBase + "/rooms/:id/sessions/count",
              method: "GET",
            },

            // INTERNAL. Use Room.widgets() instead.
            "prototype$__get__widgets": {
              isArray: true,
              url: urlBase + "/rooms/:id/widgets",
              method: "GET",
            },

            // INTERNAL. Use Room.widgets.create() instead.
            "prototype$__create__widgets": {
              url: urlBase + "/rooms/:id/widgets",
              method: "POST",
            },

            // INTERNAL. Use Room.widgets.destroyAll() instead.
            "prototype$__delete__widgets": {
              url: urlBase + "/rooms/:id/widgets",
              method: "DELETE",
            },

            // INTERNAL. Use Room.users() instead.
            "prototype$__get__users": {
              isArray: true,
              url: urlBase + "/rooms/:id/users",
              method: "GET",
            },

            // INTERNAL. Use Room.roomMemberships() instead.
            "prototype$__get__roomMemberships": {
              isArray: true,
              url: urlBase + "/rooms/:id/roomMemberships",
              method: "GET",
            },

            // INTERNAL. Use Room.roomMemberships.create() instead.
            "prototype$__create__roomMemberships": {
              url: urlBase + "/rooms/:id/roomMemberships",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#replaceOrCreate
             * @methodOf lbServices.Room
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/rooms/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#upsertWithWhere
             * @methodOf lbServices.Room
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/rooms/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#replaceById
             * @methodOf lbServices.Room
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/rooms/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#deleteById
             * @methodOf lbServices.Room
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/rooms/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#prototype$updateAttributes
             * @methodOf lbServices.Room
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/rooms/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#hints
             * @methodOf lbServices.Room
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `slug` – `{string}` -
             *
             *  - `domain` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{string=}` -
             *
             *  - `hints` – `{*=}` -
             */
            "hints": {
              url: urlBase + "/rooms/hints",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#prototype$sendInviteNotification
             * @methodOf lbServices.Room
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `tokenId` – `{string}` -
             *
             *  - `req` – `{undefined=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
            "prototype$sendInviteNotification": {
              url: urlBase + "/rooms/:id/sendInviteNotification",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#prototype$isValidPasscode
             * @methodOf lbServices.Room
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `passcode` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `isValid` – `{boolean=}` -
             */
            "prototype$isValidPasscode": {
              url: urlBase + "/rooms/:id/isValidPasscode",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#prototype$sendChatNotificationAboutSuccessfulTransfer
             * @methodOf lbServices.Room
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `userId` – `{string=}` -
             *
             *  - `senderNotifyKey` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$sendChatNotificationAboutSuccessfulTransfer": {
              url: urlBase + "/rooms/:id/sendChatNotificationAboutSuccessfulTransfer",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#createChannel
             * @methodOf lbServices.Room
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `uuid` – `{string=}` -
             *
             *  - `mediaMode` – `{string=}` -
             *
             *  - `roomId` – `{number=}` -
             *
             *  - `req` – `{undefined=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `channel` – `{string=}` -
             *
             *  - `token` – `{string=}` -
             *
             *  - `config` – `{object=}` -
             */
            "createChannel": {
              url: urlBase + "/rooms/createChannel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#createTestingChannel
             * @methodOf lbServices.Room
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `uuid` – `{string=}` -
             *
             *  - `mediaMode` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `channel` – `{string=}` -
             *
             *  - `token` – `{string=}` -
             */
            "createTestingChannel": {
              url: urlBase + "/rooms/createTestingChannel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#findRoomById
             * @methodOf lbServices.Room
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `id` – `{number}` -
             *
             *  - `include` – `{*=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
            "findRoomById": {
              url: urlBase + "/rooms/findRoomById/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#findBySlug
             * @methodOf lbServices.Room
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `slug` – `{string}` -
             *
             *  - `institutionId` – `{number=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
            "findBySlug": {
              url: urlBase + "/rooms/slug/:slug",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#findOneSecure
             * @methodOf lbServices.Room
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `filter` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
            "findOneSecure": {
              url: urlBase + "/rooms/findOneSecure",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#isUnique
             * @methodOf lbServices.Room
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `slug` – `{string}` -
             *
             *  - `institutionId` – `{number=}` -
             *
             *  - `tokenToIgnore` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
            "isUnique": {
              url: urlBase + "/rooms/isUnique",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#joinChannel
             * @methodOf lbServices.Room
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `channel` – `{string}` -
             *
             *  - `uuid` – `{string=}` -
             *
             *  - `username` – `{string=}` -
             *
             *  - `roomId` – `{number=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
            "joinChannel": {
              url: urlBase + "/rooms/joinChannel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#xirSys
             * @methodOf lbServices.Room
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method does not accept any data. Supply an empty object.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
            "xirSys": {
              url: urlBase + "/rooms/xirSys",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#prototype$grantMemberAccess
             * @methodOf lbServices.Room
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `channels` – `{*}` -
             *
             *  - `authorization` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `token` – `{string=}` -
             */
            "prototype$grantMemberAccess": {
              url: urlBase + "/rooms/:id/grantMemberAccess",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#prototype$onCheckIn
             * @methodOf lbServices.Room
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `name` – `{string}` -
             *
             *  - `pid` – `{string=}` -
             *
             *  - `ts` – `{number=}` -
             *
             *  - `url` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
            "prototype$onCheckIn": {
              url: urlBase + "/rooms/:id/onCheckIn",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#prototype$notifyMembersAboutPatient
             * @methodOf lbServices.Room
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `name` – `{string}` -
             *
             *  - `anonymousId` – `{string=}` -
             *
             *  - `platformData` – `{object=}` -
             *
             *  - `ctx` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
            "prototype$notifyMembersAboutPatient": {
              url: urlBase + "/rooms/:id/notifyMembersAboutPatient",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#prototype$notifyMembersAboutTransfer
             * @methodOf lbServices.Room
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `name` – `{string}` -
             *
             *  - `fromRoomId` – `{number}` -
             *
             *  - `anonymousId` – `{string=}` -
             *
             *  - `platformData` – `{object=}` -
             *
             *  - `ctx` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
            "prototype$notifyMembersAboutTransfer": {
              url: urlBase + "/rooms/:id/notifyMembersAboutTransfer",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#prototype$getVideoProvider
             * @methodOf lbServices.Room
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
            "prototype$getVideoProvider": {
              url: urlBase + "/rooms/:id/getVideoProvider",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#prototype$inviteByEmail
             * @methodOf lbServices.Room
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `email` – `{string}` -
             *
             *  - `language` – `{string=}` -
             *
             *  - `edited` – `{boolean}` -
             *
             *  - `message` – `{string}` -
             *
             *  - `calendarICS` – `{string=}` -
             *
             *  - `ctx` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
            "prototype$inviteByEmail": {
              url: urlBase + "/rooms/:id/inviteByEmail",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#prototype$inviteBySms
             * @methodOf lbServices.Room
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `phone` – `{string}` -
             *
             *  - `language` – `{string}` -
             *
             *  - `edited` – `{boolean}` -
             *
             *  - `message` – `{string}` -
             *
             *  - `token` – `{string=}` -
             *
             *  - `ctx` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
            "prototype$inviteBySms": {
              url: urlBase + "/rooms/:id/inviteBySms",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Room#sharedUsers
             * @methodOf lbServices.Room
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `id` – `{number}` -
             *
             *  - `query` – `{string=}` -
             *
             *  - `limit` – `{number=}` -
             *
             *  - `offset` – `{number=}` -
             *
             *  - `sortBy` – `{string=}` -
             *
             *  - `isDesc` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
            "sharedUsers": {
              url: urlBase + "/rooms/:id/sharedUsers",
              method: "GET",
            },

            // INTERNAL. Use Institution.rooms.findById() instead.
            "::findById::Institution::rooms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/institutions/:id/rooms/:fk",
              method: "GET",
            },

            // INTERNAL. Use Institution.rooms() instead.
            "::get::Institution::rooms": {
              isArray: true,
              url: urlBase + "/institutions/:id/rooms",
              method: "GET",
            },

            // INTERNAL. Use Institution.rooms.count() instead.
            "::count::Institution::rooms": {
              url: urlBase + "/institutions/:id/rooms/count",
              method: "GET",
            },

            // INTERNAL. Use RoomWidget.room() instead.
            "::get::RoomWidget::room": {
              url: urlBase + "/roomWidgets/:id/room",
              method: "GET",
            },

            // INTERNAL. Use User.createdRooms.findById() instead.
            "::findById::User::createdRooms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/createdRooms/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.createManydRooms.findById() instead.
            "::findById::User::createManydRooms": {
              isArray: true,
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/createdRooms/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.createdRooms.destroyById() instead.
            "::destroyById::User::createdRooms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/createdRooms/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.createManydRooms.destroyById() instead.
            "::destroyById::User::createManydRooms": {
              isArray: true,
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/createdRooms/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.createdRooms.updateById() instead.
            "::updateById::User::createdRooms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/createdRooms/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.createManydRooms.updateById() instead.
            "::updateById::User::createManydRooms": {
              isArray: true,
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/createdRooms/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.rooms.findById() instead.
            "::findById::User::rooms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/rooms/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.rooms.updateById() instead.
            "::updateById::User::rooms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/rooms/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.rooms.link() instead.
            "::link::User::rooms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/rooms/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.rooms.unlink() instead.
            "::unlink::User::rooms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/rooms/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.rooms.exists() instead.
            "::exists::User::rooms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/rooms/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use User.createdRooms() instead.
            "::get::User::createdRooms": {
              isArray: true,
              url: urlBase + "/users/:id/createdRooms",
              method: "GET",
            },

            // INTERNAL. Use User.createManydRooms() instead.
            "::get::User::createManydRooms": {
              isArray: true,
              url: urlBase + "/users/:id/createdRooms",
              method: "GET",
            },

            // INTERNAL. Use User.createdRooms.create() instead.
            "::create::User::createdRooms": {
              url: urlBase + "/users/:id/createdRooms",
              method: "POST",
            },

            // INTERNAL. Use User.createManydRooms.create() instead.
            "::createMany::User::createdRooms": {
              isArray: true,
              url: urlBase + "/users/:id/createdRooms",
              method: "POST",
            },

            // INTERNAL. Use User.createdRooms.destroyAll() instead.
            "::delete::User::createdRooms": {
              url: urlBase + "/users/:id/createdRooms",
              method: "DELETE",
            },

            // INTERNAL. Use User.createManydRooms.destroyAll() instead.
            "::delete::User::createManydRooms": {
              isArray: true,
              url: urlBase + "/users/:id/createdRooms",
              method: "DELETE",
            },

            // INTERNAL. Use User.createdRooms.count() instead.
            "::count::User::createdRooms": {
              url: urlBase + "/users/:id/createdRooms/count",
              method: "GET",
            },

            // INTERNAL. Use User.createManydRooms.count() instead.
            "::count::User::createManydRooms": {
              isArray: true,
              url: urlBase + "/users/:id/createdRooms/count",
              method: "GET",
            },

            // INTERNAL. Use User.rooms() instead.
            "::get::User::rooms": {
              isArray: true,
              url: urlBase + "/users/:id/rooms",
              method: "GET",
            },

            // INTERNAL. Use User.rooms.create() instead.
            "::create::User::rooms": {
              url: urlBase + "/users/:id/rooms",
              method: "POST",
            },

            // INTERNAL. Use User.rooms.createMany() instead.
            "::createMany::User::rooms": {
              isArray: true,
              url: urlBase + "/users/:id/rooms",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Room#patchOrCreateWithWhere
             * @methodOf lbServices.Room
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Room#destroyById
             * @methodOf lbServices.Room
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Room#removeById
             * @methodOf lbServices.Room
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Room#patchAttributes
             * @methodOf lbServices.Room
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Room#modelName
        * @propertyOf lbServices.Room
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Room`.
        */
        R.modelName = "Room";

    /**
     * @ngdoc object
     * @name lbServices.Room.sessions
     * @header lbServices.Room.sessions
     * @object
     * @description
     *
     * The object `Room.sessions` groups methods
     * manipulating `CallSession` instances related to `Room`.
     *
     * Call {@link lbServices.Room#sessions Room.sessions()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Room#sessions
             * @methodOf lbServices.Room
             *
             * @description
             *
             * Queries sessions of room.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallSession` object.)
             * </em>
             */
        R.sessions = function() {
          var TargetResource = $injector.get("CallSession");
          var action = TargetResource["::get::Room::sessions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Room.sessions#count
             * @methodOf lbServices.Room.sessions
             *
             * @description
             *
             * Counts sessions of room.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.sessions.count = function() {
          var TargetResource = $injector.get("CallSession");
          var action = TargetResource["::count::Room::sessions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Room.sessions#create
             * @methodOf lbServices.Room.sessions
             *
             * @description
             *
             * Creates a new instance in sessions of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallSession` object.)
             * </em>
             */
        R.sessions.create = function() {
          var TargetResource = $injector.get("CallSession");
          var action = TargetResource["::create::Room::sessions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Room.sessions#createMany
             * @methodOf lbServices.Room.sessions
             *
             * @description
             *
             * Creates a new instance in sessions of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallSession` object.)
             * </em>
             */
        R.sessions.createMany = function() {
          var TargetResource = $injector.get("CallSession");
          var action = TargetResource["::createMany::Room::sessions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Room.sessions#updateById
             * @methodOf lbServices.Room.sessions
             *
             * @description
             *
             * Update a related item by id for sessions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             *  - `fk` – `{*}` - Foreign key for sessions
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallSession` object.)
             * </em>
             */
        R.sessions.updateById = function() {
          var TargetResource = $injector.get("CallSession");
          var action = TargetResource["::updateById::Room::sessions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Room#user
             * @methodOf lbServices.Room
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Room::user"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Room.users
     * @header lbServices.Room.users
     * @object
     * @description
     *
     * The object `Room.users` groups methods
     * manipulating `User` instances related to `Room`.
     *
     * Call {@link lbServices.Room#users Room.users()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Room#users
             * @methodOf lbServices.Room
             *
             * @description
             *
             * Queries users of room.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.users = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Room::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Room.users#exists
             * @methodOf lbServices.Room.users
             *
             * @description
             *
             * Check the existence of users relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for users
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.users.exists = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::exists::Room::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Room.users#findById
             * @methodOf lbServices.Room.users
             *
             * @description
             *
             * Find a related item by id for users.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for users
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.users.findById = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::findById::Room::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Room.users#link
             * @methodOf lbServices.Room.users
             *
             * @description
             *
             * Add a related item by id for users.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             *  - `fk` – `{*}` - Foreign key for users
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.users.link = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::link::Room::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Room.users#unlink
             * @methodOf lbServices.Room.users
             *
             * @description
             *
             * Remove the users relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for users
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.users.unlink = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::unlink::Room::users"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Room.roomMemberships
     * @header lbServices.Room.roomMemberships
     * @object
     * @description
     *
     * The object `Room.roomMemberships` groups methods
     * manipulating `RoomMember` instances related to `Room`.
     *
     * Call {@link lbServices.Room#roomMemberships Room.roomMemberships()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Room#roomMemberships
             * @methodOf lbServices.Room
             *
             * @description
             *
             * Queries roomMemberships of room.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoomMember` object.)
             * </em>
             */
        R.roomMemberships = function() {
          var TargetResource = $injector.get("RoomMember");
          var action = TargetResource["::get::Room::roomMemberships"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Room.roomMemberships#create
             * @methodOf lbServices.Room.roomMemberships
             *
             * @description
             *
             * Creates a new instance in roomMemberships of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoomMember` object.)
             * </em>
             */
        R.roomMemberships.create = function() {
          var TargetResource = $injector.get("RoomMember");
          var action = TargetResource["::create::Room::roomMemberships"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Room.roomMemberships#createMany
             * @methodOf lbServices.Room.roomMemberships
             *
             * @description
             *
             * Creates a new instance in roomMemberships of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoomMember` object.)
             * </em>
             */
        R.roomMemberships.createMany = function() {
          var TargetResource = $injector.get("RoomMember");
          var action = TargetResource["::createMany::Room::roomMemberships"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Room.roomMemberships#destroyById
             * @methodOf lbServices.Room.roomMemberships
             *
             * @description
             *
             * Delete a related item by id for roomMemberships.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for roomMemberships
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.roomMemberships.destroyById = function() {
          var TargetResource = $injector.get("RoomMember");
          var action = TargetResource["::destroyById::Room::roomMemberships"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Room.roomMemberships#updateById
             * @methodOf lbServices.Room.roomMemberships
             *
             * @description
             *
             * Update a related item by id for roomMemberships.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             *  - `fk` – `{*}` - Foreign key for roomMemberships
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoomMember` object.)
             * </em>
             */
        R.roomMemberships.updateById = function() {
          var TargetResource = $injector.get("RoomMember");
          var action = TargetResource["::updateById::Room::roomMemberships"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Room.widgets
     * @header lbServices.Room.widgets
     * @object
     * @description
     *
     * The object `Room.widgets` groups methods
     * manipulating `RoomWidget` instances related to `Room`.
     *
     * Call {@link lbServices.Room#widgets Room.widgets()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Room#widgets
             * @methodOf lbServices.Room
             *
             * @description
             *
             * Queries widgets of room.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoomWidget` object.)
             * </em>
             */
        R.widgets = function() {
          var TargetResource = $injector.get("RoomWidget");
          var action = TargetResource["::get::Room::widgets"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Room.widgets#create
             * @methodOf lbServices.Room.widgets
             *
             * @description
             *
             * Creates a new instance in widgets of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoomWidget` object.)
             * </em>
             */
        R.widgets.create = function() {
          var TargetResource = $injector.get("RoomWidget");
          var action = TargetResource["::create::Room::widgets"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Room.widgets#createMany
             * @methodOf lbServices.Room.widgets
             *
             * @description
             *
             * Creates a new instance in widgets of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoomWidget` object.)
             * </em>
             */
        R.widgets.createMany = function() {
          var TargetResource = $injector.get("RoomWidget");
          var action = TargetResource["::createMany::Room::widgets"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Room.widgets#destroyAll
             * @methodOf lbServices.Room.widgets
             *
             * @description
             *
             * Deletes all widgets of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - room id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.widgets.destroyAll = function() {
          var TargetResource = $injector.get("RoomWidget");
          var action = TargetResource["::delete::Room::widgets"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.CallSession
 * @header lbServices.CallSession
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `CallSession` model.
 *
 * **Details**
 *
 * Keep track of calls
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "CallSession",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/sessions/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use CallSession.sessionParticipants.findById() instead.
            "prototype$__findById__sessionParticipants": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/sessions/:id/sessionParticipants/:fk",
              method: "GET",
            },

            // INTERNAL. Use CallSession.sessionParticipants.destroyById() instead.
            "prototype$__destroyById__sessionParticipants": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/sessions/:id/sessionParticipants/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use CallSession.sessionParticipants.updateById() instead.
            "prototype$__updateById__sessionParticipants": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/sessions/:id/sessionParticipants/:fk",
              method: "PUT",
            },

            // INTERNAL. Use CallSession.sessionParticipants() instead.
            "prototype$__get__sessionParticipants": {
              isArray: true,
              url: urlBase + "/sessions/:id/sessionParticipants",
              method: "GET",
            },

            // INTERNAL. Use CallSession.sessionParticipants.create() instead.
            "prototype$__create__sessionParticipants": {
              url: urlBase + "/sessions/:id/sessionParticipants",
              method: "POST",
            },

            // INTERNAL. Use CallSession.sessionParticipants.destroyAll() instead.
            "prototype$__delete__sessionParticipants": {
              url: urlBase + "/sessions/:id/sessionParticipants",
              method: "DELETE",
            },

            // INTERNAL. Use CallSession.sessionParticipants.count() instead.
            "prototype$__count__sessionParticipants": {
              url: urlBase + "/sessions/:id/sessionParticipants/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallSession#replaceOrCreate
             * @methodOf lbServices.CallSession
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallSession` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/sessions/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallSession#upsertWithWhere
             * @methodOf lbServices.CallSession
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallSession` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/sessions/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallSession#replaceById
             * @methodOf lbServices.CallSession
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallSession` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/sessions/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallSession#prototype$end
             * @methodOf lbServices.CallSession
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - callSession id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `participantsCount` – `{number=}` -
             *
             *  - `connectionInfo` – `{object=}` -
             *
             *  - `object` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$end": {
              url: urlBase + "/sessions/:id/end",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallSession#tokboxSessionCallback
             * @methodOf lbServices.CallSession
             *
             * @description
             *
             * Webhook when session created or destroyed
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `object` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "tokboxSessionCallback": {
              url: urlBase + "/sessions/tokbox-session-callback",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallSession#prototype$addPid
             * @methodOf lbServices.CallSession
             *
             * @description
             *
             * Add patient's PID to session
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - callSession id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `pid` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$addPid": {
              url: urlBase + "/sessions/:id/addPid",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallSession#getMeetingHistory
             * @methodOf lbServices.CallSession
             *
             * @description
             *
             * Export a list of sessions
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `institutionId` – `{number=}` -
             *
             *  - `userIds` – `{*=}` -
             *
             *  - `roomIds` – `{*=}` -
             *
             *  - `locationIds` – `{*=}` -
             *
             *  - `start` – `{date}` -
             *
             *  - `end` – `{date}` -
             *
             *  - `offset` – `{number=}` -
             *
             *  - `limit` – `{number=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallSession` object.)
             * </em>
             */
            "getMeetingHistory": {
              url: urlBase + "/sessions/getMeetingHistory",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallSession#getMeetingHistoryForCSV
             * @methodOf lbServices.CallSession
             *
             * @description
             *
             * Export a list of sessions
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `institutionId` – `{number=}` -
             *
             *  - `userIds` – `{*=}` -
             *
             *  - `roomIds` – `{*=}` -
             *
             *  - `locationIds` – `{*=}` -
             *
             *  - `start` – `{date}` -
             *
             *  - `end` – `{date}` -
             *
             *  - `timeOffset` – `{number=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallSession` object.)
             * </em>
             */
            "getMeetingHistoryForCSV": {
              url: urlBase + "/sessions/getMeetingHistoryForCSV",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallSession#exportClinic
             * @methodOf lbServices.CallSession
             *
             * @description
             *
             * Export a list of sessions
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `ctx` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallSession` object.)
             * </em>
             */
            "exportClinic": {
              isArray: true,
              url: urlBase + "/sessions/exportClinic",
              method: "GET",
            },

            // INTERNAL. Use Room.sessions.updateById() instead.
            "::updateById::Room::sessions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/rooms/:id/sessions/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Room.sessions() instead.
            "::get::Room::sessions": {
              isArray: true,
              url: urlBase + "/rooms/:id/sessions",
              method: "GET",
            },

            // INTERNAL. Use Room.sessions.create() instead.
            "::create::Room::sessions": {
              url: urlBase + "/rooms/:id/sessions",
              method: "POST",
            },

            // INTERNAL. Use Room.sessions.createMany() instead.
            "::createMany::Room::sessions": {
              isArray: true,
              url: urlBase + "/rooms/:id/sessions",
              method: "POST",
            },

            // INTERNAL. Use Room.sessions.count() instead.
            "::count::Room::sessions": {
              url: urlBase + "/rooms/:id/sessions/count",
              method: "GET",
            },

            // INTERNAL. Use User.sessions.findById() instead.
            "::findById::User::sessions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/sessions/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.sessions.updateById() instead.
            "::updateById::User::sessions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/sessions/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.sessions() instead.
            "::get::User::sessions": {
              isArray: true,
              url: urlBase + "/users/:id/sessions",
              method: "GET",
            },

            // INTERNAL. Use User.sessions.create() instead.
            "::create::User::sessions": {
              url: urlBase + "/users/:id/sessions",
              method: "POST",
            },

            // INTERNAL. Use User.sessions.createMany() instead.
            "::createMany::User::sessions": {
              isArray: true,
              url: urlBase + "/users/:id/sessions",
              method: "POST",
            },

            // INTERNAL. Use User.sessions.count() instead.
            "::count::User::sessions": {
              url: urlBase + "/users/:id/sessions/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.CallSession#patchOrCreateWithWhere
             * @methodOf lbServices.CallSession
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallSession` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];


        /**
        * @ngdoc property
        * @name lbServices.CallSession#modelName
        * @propertyOf lbServices.CallSession
        * @description
        * The name of the model represented by this $resource,
        * i.e. `CallSession`.
        */
        R.modelName = "CallSession";

    /**
     * @ngdoc object
     * @name lbServices.CallSession.sessionParticipants
     * @header lbServices.CallSession.sessionParticipants
     * @object
     * @description
     *
     * The object `CallSession.sessionParticipants` groups methods
     * manipulating `SessionParticipant` instances related to `CallSession`.
     *
     * Call {@link lbServices.CallSession#sessionParticipants CallSession.sessionParticipants()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.CallSession#sessionParticipants
             * @methodOf lbServices.CallSession
             *
             * @description
             *
             * Queries sessionParticipants of callSession.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - callSession id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SessionParticipant` object.)
             * </em>
             */
        R.sessionParticipants = function() {
          var TargetResource = $injector.get("SessionParticipant");
          var action = TargetResource["::get::CallSession::sessionParticipants"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CallSession.sessionParticipants#count
             * @methodOf lbServices.CallSession.sessionParticipants
             *
             * @description
             *
             * Counts sessionParticipants of callSession.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - callSession id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.sessionParticipants.count = function() {
          var TargetResource = $injector.get("SessionParticipant");
          var action = TargetResource["::count::CallSession::sessionParticipants"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CallSession.sessionParticipants#create
             * @methodOf lbServices.CallSession.sessionParticipants
             *
             * @description
             *
             * Creates a new instance in sessionParticipants of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - callSession id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SessionParticipant` object.)
             * </em>
             */
        R.sessionParticipants.create = function() {
          var TargetResource = $injector.get("SessionParticipant");
          var action = TargetResource["::create::CallSession::sessionParticipants"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CallSession.sessionParticipants#createMany
             * @methodOf lbServices.CallSession.sessionParticipants
             *
             * @description
             *
             * Creates a new instance in sessionParticipants of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - callSession id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SessionParticipant` object.)
             * </em>
             */
        R.sessionParticipants.createMany = function() {
          var TargetResource = $injector.get("SessionParticipant");
          var action = TargetResource["::createMany::CallSession::sessionParticipants"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CallSession.sessionParticipants#destroyAll
             * @methodOf lbServices.CallSession.sessionParticipants
             *
             * @description
             *
             * Deletes all sessionParticipants of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - callSession id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.sessionParticipants.destroyAll = function() {
          var TargetResource = $injector.get("SessionParticipant");
          var action = TargetResource["::delete::CallSession::sessionParticipants"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CallSession.sessionParticipants#destroyById
             * @methodOf lbServices.CallSession.sessionParticipants
             *
             * @description
             *
             * Delete a related item by id for sessionParticipants.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - callSession id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for sessionParticipants
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.sessionParticipants.destroyById = function() {
          var TargetResource = $injector.get("SessionParticipant");
          var action = TargetResource["::destroyById::CallSession::sessionParticipants"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CallSession.sessionParticipants#findById
             * @methodOf lbServices.CallSession.sessionParticipants
             *
             * @description
             *
             * Find a related item by id for sessionParticipants.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - callSession id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for sessionParticipants
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SessionParticipant` object.)
             * </em>
             */
        R.sessionParticipants.findById = function() {
          var TargetResource = $injector.get("SessionParticipant");
          var action = TargetResource["::findById::CallSession::sessionParticipants"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CallSession.sessionParticipants#updateById
             * @methodOf lbServices.CallSession.sessionParticipants
             *
             * @description
             *
             * Update a related item by id for sessionParticipants.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - callSession id
             *
             *  - `fk` – `{*}` - Foreign key for sessionParticipants
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SessionParticipant` object.)
             * </em>
             */
        R.sessionParticipants.updateById = function() {
          var TargetResource = $injector.get("SessionParticipant");
          var action = TargetResource["::updateById::CallSession::sessionParticipants"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.BetaFeatures
 * @header lbServices.BetaFeatures
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `BetaFeatures` model.
 *
 * **Details**
 *
 * Provides enums of a beta features
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "BetaFeatures",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/betaFeatures/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.BetaFeatures#create
             * @methodOf lbServices.BetaFeatures
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BetaFeatures` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/betaFeatures",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BetaFeatures#createMany
             * @methodOf lbServices.BetaFeatures
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BetaFeatures` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/betaFeatures",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BetaFeatures#replaceOrCreate
             * @methodOf lbServices.BetaFeatures
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BetaFeatures` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/betaFeatures/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BetaFeatures#upsertWithWhere
             * @methodOf lbServices.BetaFeatures
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BetaFeatures` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/betaFeatures/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BetaFeatures#replaceById
             * @methodOf lbServices.BetaFeatures
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BetaFeatures` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/betaFeatures/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BetaFeatures#createBetaFeature
             * @methodOf lbServices.BetaFeatures
             *
             * @description
             *
             * Create beta feature
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `name` – `{string}` -
             *
             *  - `description` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BetaFeatures` object.)
             * </em>
             */
            "createBetaFeature": {
              url: urlBase + "/betaFeatures/createBetaFeature",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BetaFeatures#softDeleteBetaFeature
             * @methodOf lbServices.BetaFeatures
             *
             * @description
             *
             * Disable beta feature
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `name` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BetaFeatures` object.)
             * </em>
             */
            "softDeleteBetaFeature": {
              url: urlBase + "/betaFeatures/softDeleteBetaFeature",
              method: "PATCH",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.BetaFeatures#patchOrCreateWithWhere
             * @methodOf lbServices.BetaFeatures
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BetaFeatures` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];


        /**
        * @ngdoc property
        * @name lbServices.BetaFeatures#modelName
        * @propertyOf lbServices.BetaFeatures
        * @description
        * The name of the model represented by this $resource,
        * i.e. `BetaFeatures`.
        */
        R.modelName = "BetaFeatures";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.SessionParticipant
 * @header lbServices.SessionParticipant
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `SessionParticipant` model.
 *
 * **Details**
 *
 * Provides additional information on callSession participants
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "SessionParticipant",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/sessionParticipants/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.SessionParticipant#create
             * @methodOf lbServices.SessionParticipant
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SessionParticipant` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/sessionParticipants",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SessionParticipant#createMany
             * @methodOf lbServices.SessionParticipant
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SessionParticipant` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/sessionParticipants",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SessionParticipant#replaceOrCreate
             * @methodOf lbServices.SessionParticipant
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SessionParticipant` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/sessionParticipants/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SessionParticipant#upsertWithWhere
             * @methodOf lbServices.SessionParticipant
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SessionParticipant` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/sessionParticipants/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SessionParticipant#replaceById
             * @methodOf lbServices.SessionParticipant
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SessionParticipant` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/sessionParticipants/:id/replace",
              method: "POST",
            },

            // INTERNAL. Use CallSession.sessionParticipants.findById() instead.
            "::findById::CallSession::sessionParticipants": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/sessions/:id/sessionParticipants/:fk",
              method: "GET",
            },

            // INTERNAL. Use CallSession.sessionParticipants.destroyById() instead.
            "::destroyById::CallSession::sessionParticipants": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/sessions/:id/sessionParticipants/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use CallSession.sessionParticipants.updateById() instead.
            "::updateById::CallSession::sessionParticipants": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/sessions/:id/sessionParticipants/:fk",
              method: "PUT",
            },

            // INTERNAL. Use CallSession.sessionParticipants() instead.
            "::get::CallSession::sessionParticipants": {
              isArray: true,
              url: urlBase + "/sessions/:id/sessionParticipants",
              method: "GET",
            },

            // INTERNAL. Use CallSession.sessionParticipants.create() instead.
            "::create::CallSession::sessionParticipants": {
              url: urlBase + "/sessions/:id/sessionParticipants",
              method: "POST",
            },

            // INTERNAL. Use CallSession.sessionParticipants.createMany() instead.
            "::createMany::CallSession::sessionParticipants": {
              isArray: true,
              url: urlBase + "/sessions/:id/sessionParticipants",
              method: "POST",
            },

            // INTERNAL. Use CallSession.sessionParticipants.destroyAll() instead.
            "::delete::CallSession::sessionParticipants": {
              url: urlBase + "/sessions/:id/sessionParticipants",
              method: "DELETE",
            },

            // INTERNAL. Use CallSession.sessionParticipants.count() instead.
            "::count::CallSession::sessionParticipants": {
              url: urlBase + "/sessions/:id/sessionParticipants/count",
              method: "GET",
            },

            // INTERNAL. Use User.sessionParticipants.findById() instead.
            "::findById::User::sessionParticipants": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/sessionParticipants/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.sessionParticipants.updateById() instead.
            "::updateById::User::sessionParticipants": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/sessionParticipants/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.sessionParticipants() instead.
            "::get::User::sessionParticipants": {
              isArray: true,
              url: urlBase + "/users/:id/sessionParticipants",
              method: "GET",
            },

            // INTERNAL. Use User.sessionParticipants.create() instead.
            "::create::User::sessionParticipants": {
              url: urlBase + "/users/:id/sessionParticipants",
              method: "POST",
            },

            // INTERNAL. Use User.sessionParticipants.createMany() instead.
            "::createMany::User::sessionParticipants": {
              isArray: true,
              url: urlBase + "/users/:id/sessionParticipants",
              method: "POST",
            },

            // INTERNAL. Use User.sessionParticipants.count() instead.
            "::count::User::sessionParticipants": {
              url: urlBase + "/users/:id/sessionParticipants/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.SessionParticipant#patchOrCreateWithWhere
             * @methodOf lbServices.SessionParticipant
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SessionParticipant` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];


        /**
        * @ngdoc property
        * @name lbServices.SessionParticipant#modelName
        * @propertyOf lbServices.SessionParticipant
        * @description
        * The name of the model represented by this $resource,
        * i.e. `SessionParticipant`.
        */
        R.modelName = "SessionParticipant";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.IntegrationWebhooks
 * @header lbServices.IntegrationWebhooks
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `IntegrationWebhooks` model.
 *
 * **Details**
 *
 * Provides information about all integration webhooks
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "IntegrationWebhooks",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/integrationWebhooks/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.IntegrationWebhooks#regenerateKeyWebHook
             * @methodOf lbServices.IntegrationWebhooks
             *
             * @description
             *
             * Regenerate key for webhooks of specific institution
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `institutionId` – `{string}` -
             *
             *  - `secretWord` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `IntegrationWebhooks` object.)
             * </em>
             */
            "regenerateKeyWebHook": {
              url: urlBase + "/integrationWebhooks/regenerateKeyWebHook",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.IntegrationWebhooks#createWebHook
             * @methodOf lbServices.IntegrationWebhooks
             *
             * @description
             *
             * Create of integration webhooks
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `institutionId` – `{string}` -
             *
             *  - `webhookName` – `{string}` -
             *
             *  - `webhookURL` – `{string}` -
             *
             *  - `status` – `{string}` -
             *
             *  - `eventType` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `IntegrationWebhooks` object.)
             * </em>
             */
            "createWebHook": {
              url: urlBase + "/integrationWebhooks/createWebHook",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.IntegrationWebhooks#updateWebHook
             * @methodOf lbServices.IntegrationWebhooks
             *
             * @description
             *
             * Update of integration webhooks
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             *  - `institutionId` – `{string}` -
             *
             *  - `webhookName` – `{string=}` -
             *
             *  - `webhookURL` – `{string=}` -
             *
             *  - `status` – `{string=}` -
             *
             *  - `eventType` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `IntegrationWebhooks` object.)
             * </em>
             */
            "updateWebHook": {
              url: urlBase + "/integrationWebhooks/updateWebHook",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.IntegrationWebhooks#getWebHook
             * @methodOf lbServices.IntegrationWebhooks
             *
             * @description
             *
             * Get integration webhooks
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string=}` -
             *
             *  - `institutionId` – `{string=}` -
             *
             *  - `webhookName` – `{string=}` -
             *
             *  - `webhookURL` – `{string=}` -
             *
             *  - `status` – `{string=}` -
             *
             *  - `eventType` – `{string=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `IntegrationWebhooks` object.)
             * </em>
             */
            "getWebHook": {
              isArray: true,
              url: urlBase + "/integrationWebhooks/getWebHook",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.IntegrationWebhooks#deleteWebHook
             * @methodOf lbServices.IntegrationWebhooks
             *
             * @description
             *
             * Delete of integration webhooks
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             *  - `institutionId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `IntegrationWebhooks` object.)
             * </em>
             */
            "deleteWebHook": {
              url: urlBase + "/integrationWebhooks/deleteWebHook",
              method: "DELETE",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.IntegrationWebhooks#modelName
        * @propertyOf lbServices.IntegrationWebhooks
        * @description
        * The name of the model represented by this $resource,
        * i.e. `IntegrationWebhooks`.
        */
        R.modelName = "IntegrationWebhooks";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.RoomWidget
 * @header lbServices.RoomWidget
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `RoomWidget` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "RoomWidget",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/roomWidgets/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use RoomWidget.room() instead.
            "prototype$__get__room": {
              url: urlBase + "/roomWidgets/:id/room",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoomWidget#prototype$__get__videoMetadata
             * @methodOf lbServices.RoomWidget
             *
             * @description
             *
             * Fetches belongsTo relation videoMetadata.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - roomWidget id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoomWidget` object.)
             * </em>
             */
            "prototype$__get__videoMetadata": {
              url: urlBase + "/roomWidgets/:id/videoMetadata",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoomWidget#replaceOrCreate
             * @methodOf lbServices.RoomWidget
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoomWidget` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/roomWidgets/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoomWidget#upsertWithWhere
             * @methodOf lbServices.RoomWidget
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoomWidget` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/roomWidgets/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoomWidget#replaceById
             * @methodOf lbServices.RoomWidget
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoomWidget` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/roomWidgets/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoomWidget#bulkSetRoomWidgets
             * @methodOf lbServices.RoomWidget
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoomWidget` object.)
             * </em>
             */
            "bulkSetRoomWidgets": {
              url: urlBase + "/roomWidgets/bulkSetRoomWidgets",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoomWidget#restoreDefaultRoomWidgets
             * @methodOf lbServices.RoomWidget
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoomWidget` object.)
             * </em>
             */
            "restoreDefaultRoomWidgets": {
              url: urlBase + "/roomWidgets/restoreDefaultRoomWidgets",
              method: "POST",
            },

            // INTERNAL. Use Room.widgets() instead.
            "::get::Room::widgets": {
              isArray: true,
              url: urlBase + "/rooms/:id/widgets",
              method: "GET",
            },

            // INTERNAL. Use Room.widgets.create() instead.
            "::create::Room::widgets": {
              url: urlBase + "/rooms/:id/widgets",
              method: "POST",
            },

            // INTERNAL. Use Room.widgets.createMany() instead.
            "::createMany::Room::widgets": {
              isArray: true,
              url: urlBase + "/rooms/:id/widgets",
              method: "POST",
            },

            // INTERNAL. Use Room.widgets.destroyAll() instead.
            "::delete::Room::widgets": {
              url: urlBase + "/rooms/:id/widgets",
              method: "DELETE",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.RoomWidget#patchOrCreateWithWhere
             * @methodOf lbServices.RoomWidget
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoomWidget` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];


        /**
        * @ngdoc property
        * @name lbServices.RoomWidget#modelName
        * @propertyOf lbServices.RoomWidget
        * @description
        * The name of the model represented by this $resource,
        * i.e. `RoomWidget`.
        */
        R.modelName = "RoomWidget";


            /**
             * @ngdoc method
             * @name lbServices.RoomWidget#room
             * @methodOf lbServices.RoomWidget
             *
             * @description
             *
             * Fetches belongsTo relation room.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - roomWidget id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
        R.room = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::get::RoomWidget::room"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.User
 * @header lbServices.User
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `User` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "User",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/users/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use User.createdRooms.findById() instead.
            "prototype$__findById__createdRooms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/createdRooms/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.createdRooms.destroyById() instead.
            "prototype$__destroyById__createdRooms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/createdRooms/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.createdRooms.updateById() instead.
            "prototype$__updateById__createdRooms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/createdRooms/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.sessions.findById() instead.
            "prototype$__findById__sessions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/sessions/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.sessions.updateById() instead.
            "prototype$__updateById__sessions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/sessions/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.documents.findById() instead.
            "prototype$__findById__documents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/documents/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.documents.destroyById() instead.
            "prototype$__destroyById__documents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/documents/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.documents.updateById() instead.
            "prototype$__updateById__documents": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/documents/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.sessionParticipants.findById() instead.
            "prototype$__findById__sessionParticipants": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/sessionParticipants/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.sessionParticipants.updateById() instead.
            "prototype$__updateById__sessionParticipants": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/sessionParticipants/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.legals.destroyById() instead.
            "prototype$__destroyById__legals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/legals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.legals.updateById() instead.
            "prototype$__updateById__legals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/legals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.locationsLicenced.findById() instead.
            "prototype$__findById__locationsLicenced": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/locationsLicenced/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.locationsLicenced.destroyById() instead.
            "prototype$__destroyById__locationsLicenced": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/locationsLicenced/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.locationsLicenced.updateById() instead.
            "prototype$__updateById__locationsLicenced": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/locationsLicenced/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.institutions.findById() instead.
            "prototype$__findById__institutions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/institutions/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.institutions.updateById() instead.
            "prototype$__updateById__institutions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/institutions/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.institutions.link() instead.
            "prototype$__link__institutions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/institutions/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.institutions.unlink() instead.
            "prototype$__unlink__institutions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/institutions/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.rooms.findById() instead.
            "prototype$__findById__rooms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/rooms/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.rooms.updateById() instead.
            "prototype$__updateById__rooms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/rooms/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.rooms.link() instead.
            "prototype$__link__rooms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/rooms/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.rooms.unlink() instead.
            "prototype$__unlink__rooms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/rooms/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.rooms.exists() instead.
            "prototype$__exists__rooms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/rooms/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use User.roomsMemberships.findById() instead.
            "prototype$__findById__roomsMemberships": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roomsMemberships/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.roomsMemberships.destroyById() instead.
            "prototype$__destroyById__roomsMemberships": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roomsMemberships/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.roomsMemberships.updateById() instead.
            "prototype$__updateById__roomsMemberships": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roomsMemberships/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.purchases.findById() instead.
            "prototype$__findById__purchases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/purchases/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.identities.findById() instead.
            "prototype$__findById__identities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/identities/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.identities.destroyById() instead.
            "prototype$__destroyById__identities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/identities/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.identities.updateById() instead.
            "prototype$__updateById__identities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/identities/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__findById__transientTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find a related item by id for transientTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for transientTokens
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__findById__transientTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/transientTokens/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__destroyById__transientTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a related item by id for transientTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for transientTokens
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__transientTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/transientTokens/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__updateById__transientTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update a related item by id for transientTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for transientTokens
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__updateById__transientTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/transientTokens/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.accessTokens() instead.
            "prototype$__get__accessTokens": {
              isArray: true,
              url: urlBase + "/users/:id/accessTokens",
              method: "GET",
            },

            // INTERNAL. Use User.createdRooms() instead.
            "prototype$__get__createdRooms": {
              isArray: true,
              url: urlBase + "/users/:id/createdRooms",
              method: "GET",
            },

            // INTERNAL. Use User.createdRooms.create() instead.
            "prototype$__create__createdRooms": {
              url: urlBase + "/users/:id/createdRooms",
              method: "POST",
            },

            // INTERNAL. Use User.createdRooms.destroyAll() instead.
            "prototype$__delete__createdRooms": {
              url: urlBase + "/users/:id/createdRooms",
              method: "DELETE",
            },

            // INTERNAL. Use User.createdRooms.count() instead.
            "prototype$__count__createdRooms": {
              url: urlBase + "/users/:id/createdRooms/count",
              method: "GET",
            },

            // INTERNAL. Use User.sessions() instead.
            "prototype$__get__sessions": {
              isArray: true,
              url: urlBase + "/users/:id/sessions",
              method: "GET",
            },

            // INTERNAL. Use User.sessions.create() instead.
            "prototype$__create__sessions": {
              url: urlBase + "/users/:id/sessions",
              method: "POST",
            },

            // INTERNAL. Use User.sessions.count() instead.
            "prototype$__count__sessions": {
              url: urlBase + "/users/:id/sessions/count",
              method: "GET",
            },

            // INTERNAL. Use User.documents() instead.
            "prototype$__get__documents": {
              isArray: true,
              url: urlBase + "/users/:id/documents",
              method: "GET",
            },

            // INTERNAL. Use User.documents.create() instead.
            "prototype$__create__documents": {
              url: urlBase + "/users/:id/documents",
              method: "POST",
            },

            // INTERNAL. Use User.sessionParticipants() instead.
            "prototype$__get__sessionParticipants": {
              isArray: true,
              url: urlBase + "/users/:id/sessionParticipants",
              method: "GET",
            },

            // INTERNAL. Use User.sessionParticipants.create() instead.
            "prototype$__create__sessionParticipants": {
              url: urlBase + "/users/:id/sessionParticipants",
              method: "POST",
            },

            // INTERNAL. Use User.sessionParticipants.count() instead.
            "prototype$__count__sessionParticipants": {
              url: urlBase + "/users/:id/sessionParticipants/count",
              method: "GET",
            },

            // INTERNAL. Use User.legals() instead.
            "prototype$__get__legals": {
              isArray: true,
              url: urlBase + "/users/:id/legals",
              method: "GET",
            },

            // INTERNAL. Use User.legals.create() instead.
            "prototype$__create__legals": {
              url: urlBase + "/users/:id/legals",
              method: "POST",
            },

            // INTERNAL. Use User.locationsLicenced() instead.
            "prototype$__get__locationsLicenced": {
              isArray: true,
              url: urlBase + "/users/:id/locationsLicenced",
              method: "GET",
            },

            // INTERNAL. Use User.locationsLicenced.create() instead.
            "prototype$__create__locationsLicenced": {
              url: urlBase + "/users/:id/locationsLicenced",
              method: "POST",
            },

            // INTERNAL. Use User.locationsLicenced.destroyAll() instead.
            "prototype$__delete__locationsLicenced": {
              url: urlBase + "/users/:id/locationsLicenced",
              method: "DELETE",
            },

            // INTERNAL. Use User.locationsLicenced.count() instead.
            "prototype$__count__locationsLicenced": {
              url: urlBase + "/users/:id/locationsLicenced/count",
              method: "GET",
            },

            // INTERNAL. Use User.institutions() instead.
            "prototype$__get__institutions": {
              isArray: true,
              url: urlBase + "/users/:id/institutions",
              method: "GET",
            },

            // INTERNAL. Use User.rooms() instead.
            "prototype$__get__rooms": {
              isArray: true,
              url: urlBase + "/users/:id/rooms",
              method: "GET",
            },

            // INTERNAL. Use User.rooms.create() instead.
            "prototype$__create__rooms": {
              url: urlBase + "/users/:id/rooms",
              method: "POST",
            },

            // INTERNAL. Use User.roomsMemberships() instead.
            "prototype$__get__roomsMemberships": {
              isArray: true,
              url: urlBase + "/users/:id/roomsMemberships",
              method: "GET",
            },

            // INTERNAL. Use User.roomsMemberships.create() instead.
            "prototype$__create__roomsMemberships": {
              url: urlBase + "/users/:id/roomsMemberships",
              method: "POST",
            },

            // INTERNAL. Use User.roomsMemberships.destroyAll() instead.
            "prototype$__delete__roomsMemberships": {
              url: urlBase + "/users/:id/roomsMemberships",
              method: "DELETE",
            },

            // INTERNAL. Use User.roomsMemberships.count() instead.
            "prototype$__count__roomsMemberships": {
              url: urlBase + "/users/:id/roomsMemberships/count",
              method: "GET",
            },

            // INTERNAL. Use User.purchases() instead.
            "prototype$__get__purchases": {
              isArray: true,
              url: urlBase + "/users/:id/purchases",
              method: "GET",
            },

            // INTERNAL. Use User.purchases.count() instead.
            "prototype$__count__purchases": {
              url: urlBase + "/users/:id/purchases/count",
              method: "GET",
            },

            // INTERNAL. Use User.identities() instead.
            "prototype$__get__identities": {
              isArray: true,
              url: urlBase + "/users/:id/identities",
              method: "GET",
            },

            // INTERNAL. Use User.identities.create() instead.
            "prototype$__create__identities": {
              url: urlBase + "/users/:id/identities",
              method: "POST",
            },

            // INTERNAL. Use User.identities.destroyAll() instead.
            "prototype$__delete__identities": {
              url: urlBase + "/users/:id/identities",
              method: "DELETE",
            },

            // INTERNAL. Use User.identities.count() instead.
            "prototype$__count__identities": {
              url: urlBase + "/users/:id/identities/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__get__transientTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries transientTokens of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__get__transientTokens": {
              isArray: true,
              url: urlBase + "/users/:id/transientTokens",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__create__transientTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Creates a new instance in transientTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__create__transientTokens": {
              url: urlBase + "/users/:id/transientTokens",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__delete__transientTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Deletes all transientTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__transientTokens": {
              url: urlBase + "/users/:id/transientTokens",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__count__transientTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Counts transientTokens of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__transientTokens": {
              url: urlBase + "/users/:id/transientTokens/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#create
             * @methodOf lbServices.User
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/users",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#createMany
             * @methodOf lbServices.User
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/users",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#upsert
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/users",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#replaceOrCreate
             * @methodOf lbServices.User
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/users/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#upsertWithWhere
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/users/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#findById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/users/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#replaceById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/users/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#find
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/users",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#count
             * @methodOf lbServices.User
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/users/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$updateAttributes
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/users/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#login
             * @methodOf lbServices.User
             *
             * @description
             *
             * Login a user with username/email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `include` – `{string=}` - Related objects to include in the response. See the description of return value for more details.
             *   Default value: `user`.
             *
             *  - `rememberMe` - `boolean` - Whether the authentication credentials
             *     should be remembered in localStorage across app/browser restarts.
             *     Default: `true`.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The response body contains properties of the AccessToken created on login.
             * Depending on the value of `include` parameter, the body may contain additional properties:
             *   - `user` - `U+007BUserU+007D` - Data of the currently logged in user. (`include=user`)
             *
             */
            "login": {
              params: {
                include: 'user',
              },
              interceptor: {
                response: function(response) {
                  var accessToken = response.data;
                  LoopBackAuth.setUser(
                    accessToken.id, accessToken.userId, accessToken.user);
                  LoopBackAuth.rememberMe =
                    response.config.params.rememberMe !== false;
                  LoopBackAuth.save();
                  return response.resource;
                },
              },
              url: urlBase + "/users/login",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#logout
             * @methodOf lbServices.User
             *
             * @description
             *
             * Logout a user with access token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `access_token` – `{string=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "logout": {
              interceptor: {
                response: function(response) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return responseError.resource;
                },
              },
              url: urlBase + "/users/logout",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#resetPassword
             * @methodOf lbServices.User
             *
             * @description
             *
             * Reset password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "resetPassword": {
              url: urlBase + "/users/reset",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$rememberAuthState
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `res` – `{undefined=}` -
             *
             *  - `scope` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$rememberAuthState": {
              url: urlBase + "/users/:id/rememberAuthState",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#newPassword
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accessToken` – `{string}` -
             *
             *  - `password` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "newPassword": {
              url: urlBase + "/users/newPassword",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#verifyToken
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `accessToken` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "verifyToken": {
              url: urlBase + "/users/verifyToken",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$isValidPassword
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `password` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `isValid` – `{boolean=}` -
             */
            "prototype$isValidPassword": {
              url: urlBase + "/users/:id/isValidPassword",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#contact
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `reason` – `{string}` -
             *
             *  - `name` – `{string}` -
             *
             *  - `email` – `{string}` -
             *
             *  - `message` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "contact": {
              url: urlBase + "/users/contact",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#log
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `level` – `{string}` -
             *
             *  - `name` – `{string}` -
             *
             *  - `data` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "log": {
              url: urlBase + "/users/log",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$canUsePaidFeatures
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `canUsePaidFeatures` – `{boolean=}` -
             */
            "prototype$canUsePaidFeatures": {
              url: urlBase + "/users/:id/canUsePaidFeatures",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$getSubscriptionType
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `skipInstitutionCheck` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `subscriptionType` – `{string=}` -
             */
            "prototype$getSubscriptionType": {
              url: urlBase + "/users/:id/getSubscriptionType",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#unique
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `email` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `unique` – `{boolean=}` -
             */
            "unique": {
              url: urlBase + "/users/unique",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#checkUnique
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `unique` – `{boolean=}` -
             */
            "checkUnique": {
              url: urlBase + "/users/checkUnique",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$setUpStripeAuth
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `code` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$setUpStripeAuth": {
              url: urlBase + "/users/:id/setUpStripeAuth",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$generateOAuthStripeToken
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `req` – `{undefined=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `tokenId` – `{object=}` -
             */
            "prototype$generateOAuthStripeToken": {
              url: urlBase + "/users/:id/generateOAuthStripeToken",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$getOAuthStripeToken
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `req` – `{undefined=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `tokenId` – `{object=}` -
             */
            "prototype$getOAuthStripeToken": {
              url: urlBase + "/users/:id/getOAuthStripeToken",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#createDayPassPaymentIntent
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `captchaJWTToken` – `{string}` -
             *
             *  - `planId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "createDayPassPaymentIntent": {
              url: urlBase + "/users/createDayPassPaymentIntent",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#completeDaypassPurchase
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `paymentIntentId` – `{string}` -
             *
             *  - `ctx` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "completeDaypassPurchase": {
              url: urlBase + "/users/completeDaypassPurchase",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$createPaymentIntent
             * @methodOf lbServices.User
             *
             * @description
             *
             * Realtime payments endpoint
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `amount` – `{number}` -
             *
             *  - `currency` – `{string=}` -
             *
             *  - `institutionId` – `{number=}` -
             *
             *  - `idempotencyKey` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$createPaymentIntent": {
              url: urlBase + "/users/:id/createPaymentIntent",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$getCustomer
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$getCustomer": {
              url: urlBase + "/users/:id/customer",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$createCustomer
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `source` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$createCustomer": {
              url: urlBase + "/users/:id/customer",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$forceChangeCustomer
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `customerId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$forceChangeCustomer": {
              url: urlBase + "/users/:id/forceChangeCustomer",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#createCurrentPatientToken
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{undefined=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "createCurrentPatientToken": {
              url: urlBase + "/users/createCurrentPatientToken",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$updateCustomer
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `source` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$updateCustomer": {
              url: urlBase + "/users/:id/customer",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#getLocationDetails
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{undefined=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "getLocationDetails": {
              url: urlBase + "/users/getLocationDetails",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#getClientIp
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{undefined=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "getClientIp": {
              url: urlBase + "/users/getClientIp",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$createPushSubscription
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `token` – `{string}` -
             *
             *  - `institutionId` – `{number=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$createPushSubscription": {
              url: urlBase + "/users/:id/createPushSubscription",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$getCharges
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$getCharges": {
              url: urlBase + "/users/:id/charges",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$addStripeSource
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `token` – `{string}` -
             *
             *  - `captchaJWTToken` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$addStripeSource": {
              url: urlBase + "/users/:id/sources",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$previewNextPayment
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$previewNextPayment": {
              url: urlBase + "/users/:id/previewNextPayment",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#getOAuthClientById
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `clientId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "getOAuthClientById": {
              url: urlBase + "/users/getOAuthClientById",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$getPreferredCurrency
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `institutionId` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$getPreferredCurrency": {
              url: urlBase + "/users/:id/getPreferredCurrency",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$deleteUser
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `user` – `{object}` -
             *
             *  - `password` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$deleteUser": {
              url: urlBase + "/users/:id/deleteUser",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$changeUserType
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$changeUserType": {
              url: urlBase + "/users/:id/changeUserType",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$getLinkedin
             * @methodOf lbServices.User
             *
             * @description
             *
             * get LinkedIn Access token and then get Profile picture data object for LinkedIn Avatar Upload
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `code` – `{string}` - Linkedin Authorization Code
             *
             *  - `redirectUri` – `{string}` - Redirect uri back to the doxyme page after authorization
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * returns profilePicture object. Full example: test/e2e/services/linkedinPhotoMockResponse.json
             */
            "prototype$getLinkedin": {
              url: urlBase + "/users/:id/getLinkedin",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#getAnalytics
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `institutionId` – `{number=}` -
             *
             *  - `userIds` – `{*=}` -
             *
             *  - `roomIds` – `{*=}` -
             *
             *  - `locationIds` – `{*=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "getAnalytics": {
              url: urlBase + "/users/getAnalytics",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#getAnalyticsOverview
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `institutionId` – `{number=}` -
             *
             *  - `userIds` – `{*=}` -
             *
             *  - `roomIds` – `{*=}` -
             *
             *  - `locationIds` – `{*=}` -
             *
             *  - `start` – `{date}` -
             *
             *  - `end` – `{date}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "getAnalyticsOverview": {
              url: urlBase + "/users/getAnalyticsOverview",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#validateCaptcha
             * @methodOf lbServices.User
             *
             * @description
             *
             * Send captcha google token and receive doxyme JWT signed token
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `gRecaptchaResponseToken` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `token` – `{string=}` - Signed temporary JWT token
             */
            "validateCaptcha": {
              url: urlBase + "/users/validateCaptcha",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$createTestSubscription
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `planId` – `{string}` -
             *
             *  - `seats` – `{number=}` -
             *
             *  - `interval` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$createTestSubscription": {
              url: urlBase + "/users/:id/createTestSubscription",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#getCurrentTime
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "getCurrentTime": {
              url: urlBase + "/users/getCurrentTime",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$getCannyToken
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `token` – `{string=}` -
             */
            "prototype$getCannyToken": {
              url: urlBase + "/users/:id/getCannyToken",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#administration
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `query` – `{string=}` -
             *
             *  - `limit` – `{number=}` -
             *
             *  - `offset` – `{number=}` -
             *
             *  - `sortBy` – `{string=}` -
             *
             *  - `isDesc` – `{boolean=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "administration": {
              isArray: true,
              url: urlBase + "/users/administration",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#administrationCount
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `query` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "administrationCount": {
              url: urlBase + "/users/administration/count",
              method: "GET",
            },

            // INTERNAL. Use AccessToken.user() instead.
            "::get::AccessToken::user": {
              url: urlBase + "/AccessTokens/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Institution.users.link() instead.
            "::link::Institution::users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/institutions/:id/users/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Institution.users.unlink() instead.
            "::unlink::Institution::users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/institutions/:id/users/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Institution.users() instead.
            "::get::Institution::users": {
              isArray: true,
              url: urlBase + "/institutions/:id/users",
              method: "GET",
            },

            // INTERNAL. Use Room.user() instead.
            "::get::Room::user": {
              url: urlBase + "/rooms/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Room.users.findById() instead.
            "::findById::Room::users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/rooms/:id/users/:fk",
              method: "GET",
            },

            // INTERNAL. Use Room.users.link() instead.
            "::link::Room::users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/rooms/:id/users/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Room.users.unlink() instead.
            "::unlink::Room::users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/rooms/:id/users/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Room.users.exists() instead.
            "::exists::Room::users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/rooms/:id/users/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Room.users() instead.
            "::get::Room::users": {
              isArray: true,
              url: urlBase + "/rooms/:id/users",
              method: "GET",
            },

            // INTERNAL. Use Purchase.user() instead.
            "::get::Purchase::user": {
              url: urlBase + "/purchases/:id/user",
              method: "GET",
            },

            // INTERNAL. Use UserIdentity.user() instead.
            "::get::UserIdentity::user": {
              url: urlBase + "/userIdentities/:id/user",
              method: "GET",
            },

            // INTERNAL. Use ActiveDocument.user() instead.
            "::get::ActiveDocument::user": {
              url: urlBase + "/activeDocuments/:id/user",
              method: "GET",
            },

            // INTERNAL. Use UserRateLimit.user() instead.
            "::get::UserRateLimit::user": {
              url: urlBase + "/userRateLimits/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#getCurrent
             * @methodOf lbServices.User
             *
             * @description
             *
             * Get data of the currently logged user. Fail with HTTP result 401
             * when there is no user logged in.
             *
             * @param {function(Object,Object)=} successCb
             *    Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *    `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             */
            'getCurrent': {
              url: urlBase + "/users" + '/:id',
              method: 'GET',
              params: {
                id: function() {
                  var id = LoopBackAuth.currentUserId;
                  if (id == null) id = '__anonymous__';
                  return id;
                },
              },
              interceptor: {
                response: function(response) {
                  LoopBackAuth.currentUserData = response.data;
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return $q.reject(responseError);
                },
              },
              __isGetCurrentUser__: true,
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.User#patchOrCreate
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.User#updateOrCreate
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.User#patchOrCreateWithWhere
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.User#patchAttributes
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

        /**
         * @ngdoc method
         * @name lbServices.User#getCachedCurrent
         * @methodOf lbServices.User
         *
         * @description
         *
         * Get data of the currently logged user that was returned by the last
         * call to {@link lbServices.User#login} or
         * {@link lbServices.User#getCurrent}. Return null when there
         * is no user logged in or the data of the current user were not fetched
         * yet.
         *
         * @returns {Object} A User instance.
         */
        R.getCachedCurrent = function() {
          var data = LoopBackAuth.currentUserData;
          return data ? new R(data) : null;
        };

        /**
         * @ngdoc method
         * @name lbServices.User#isAuthenticated
         * @methodOf lbServices.User
         *
         * @returns {boolean} True if the current user is authenticated (logged in).
         */
        R.isAuthenticated = function() {
          return this.getCurrentId() != null;
        };

        /**
         * @ngdoc method
         * @name lbServices.User#getCurrentId
         * @methodOf lbServices.User
         *
         * @returns {Object} Id of the currently logged-in user or null.
         */
        R.getCurrentId = function() {
          return LoopBackAuth.currentUserId;
        };

        /**
        * @ngdoc property
        * @name lbServices.User#modelName
        * @propertyOf lbServices.User
        * @description
        * The name of the model represented by this $resource,
        * i.e. `User`.
        */
        R.modelName = "User";

    /**
     * @ngdoc object
     * @name lbServices.User.createdRooms
     * @header lbServices.User.createdRooms
     * @object
     * @description
     *
     * The object `User.createdRooms` groups methods
     * manipulating `Room` instances related to `User`.
     *
     * Call {@link lbServices.User#createdRooms User.createdRooms()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#createManydRooms
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries createdRooms of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
        R.createManydRooms = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::get::User::createManydRooms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.createManydRooms#count
             * @methodOf lbServices.User.createManydRooms
             *
             * @description
             *
             * Counts createdRooms of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.createManydRooms.count = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::count::User::createManydRooms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.createManydRooms#create
             * @methodOf lbServices.User.createManydRooms
             *
             * @description
             *
             * Creates a new instance in createdRooms of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
        R.createManydRooms.create = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::createMany::User::createdRooms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.createManydRooms#destroyAll
             * @methodOf lbServices.User.createManydRooms
             *
             * @description
             *
             * Deletes all createdRooms of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.createManydRooms.destroyAll = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::delete::User::createManydRooms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.createManydRooms#destroyById
             * @methodOf lbServices.User.createManydRooms
             *
             * @description
             *
             * Delete a related item by id for createdRooms.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for createdRooms
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.createManydRooms.destroyById = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::destroyById::User::createManydRooms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.createManydRooms#findById
             * @methodOf lbServices.User.createManydRooms
             *
             * @description
             *
             * Find a related item by id for createdRooms.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for createdRooms
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
        R.createManydRooms.findById = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::findById::User::createManydRooms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.createManydRooms#updateById
             * @methodOf lbServices.User.createManydRooms
             *
             * @description
             *
             * Update a related item by id for createdRooms.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for createdRooms
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
        R.createManydRooms.updateById = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::updateById::User::createManydRooms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User#createdRooms
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries createdRooms of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
        R.createdRooms = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::get::User::createdRooms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.createdRooms#count
             * @methodOf lbServices.User.createdRooms
             *
             * @description
             *
             * Counts createdRooms of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.createdRooms.count = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::count::User::createdRooms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.createdRooms#create
             * @methodOf lbServices.User.createdRooms
             *
             * @description
             *
             * Creates a new instance in createdRooms of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
        R.createdRooms.create = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::create::User::createdRooms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.createdRooms#destroyAll
             * @methodOf lbServices.User.createdRooms
             *
             * @description
             *
             * Deletes all createdRooms of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.createdRooms.destroyAll = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::delete::User::createdRooms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.createdRooms#destroyById
             * @methodOf lbServices.User.createdRooms
             *
             * @description
             *
             * Delete a related item by id for createdRooms.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for createdRooms
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.createdRooms.destroyById = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::destroyById::User::createdRooms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.createdRooms#findById
             * @methodOf lbServices.User.createdRooms
             *
             * @description
             *
             * Find a related item by id for createdRooms.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for createdRooms
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
        R.createdRooms.findById = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::findById::User::createdRooms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.createdRooms#updateById
             * @methodOf lbServices.User.createdRooms
             *
             * @description
             *
             * Update a related item by id for createdRooms.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for createdRooms
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
        R.createdRooms.updateById = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::updateById::User::createdRooms"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.sessions
     * @header lbServices.User.sessions
     * @object
     * @description
     *
     * The object `User.sessions` groups methods
     * manipulating `CallSession` instances related to `User`.
     *
     * Call {@link lbServices.User#sessions User.sessions()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#sessions
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries sessions of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallSession` object.)
             * </em>
             */
        R.sessions = function() {
          var TargetResource = $injector.get("CallSession");
          var action = TargetResource["::get::User::sessions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.sessions#count
             * @methodOf lbServices.User.sessions
             *
             * @description
             *
             * Counts sessions of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.sessions.count = function() {
          var TargetResource = $injector.get("CallSession");
          var action = TargetResource["::count::User::sessions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.sessions#create
             * @methodOf lbServices.User.sessions
             *
             * @description
             *
             * Creates a new instance in sessions of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallSession` object.)
             * </em>
             */
        R.sessions.create = function() {
          var TargetResource = $injector.get("CallSession");
          var action = TargetResource["::create::User::sessions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.sessions#createMany
             * @methodOf lbServices.User.sessions
             *
             * @description
             *
             * Creates a new instance in sessions of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallSession` object.)
             * </em>
             */
        R.sessions.createMany = function() {
          var TargetResource = $injector.get("CallSession");
          var action = TargetResource["::createMany::User::sessions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.sessions#findById
             * @methodOf lbServices.User.sessions
             *
             * @description
             *
             * Find a related item by id for sessions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for sessions
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallSession` object.)
             * </em>
             */
        R.sessions.findById = function() {
          var TargetResource = $injector.get("CallSession");
          var action = TargetResource["::findById::User::sessions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.sessions#updateById
             * @methodOf lbServices.User.sessions
             *
             * @description
             *
             * Update a related item by id for sessions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for sessions
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallSession` object.)
             * </em>
             */
        R.sessions.updateById = function() {
          var TargetResource = $injector.get("CallSession");
          var action = TargetResource["::updateById::User::sessions"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.documents
     * @header lbServices.User.documents
     * @object
     * @description
     *
     * The object `User.documents` groups methods
     * manipulating `Document` instances related to `User`.
     *
     * Call {@link lbServices.User#documents User.documents()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#documents
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries documents of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
        R.documents = function() {
          var TargetResource = $injector.get("Document");
          var action = TargetResource["::get::User::documents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.documents#create
             * @methodOf lbServices.User.documents
             *
             * @description
             *
             * Creates a new instance in documents of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
        R.documents.create = function() {
          var TargetResource = $injector.get("Document");
          var action = TargetResource["::create::User::documents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.documents#createMany
             * @methodOf lbServices.User.documents
             *
             * @description
             *
             * Creates a new instance in documents of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
        R.documents.createMany = function() {
          var TargetResource = $injector.get("Document");
          var action = TargetResource["::createMany::User::documents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.documents#destroyById
             * @methodOf lbServices.User.documents
             *
             * @description
             *
             * Delete a related item by id for documents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for documents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.documents.destroyById = function() {
          var TargetResource = $injector.get("Document");
          var action = TargetResource["::destroyById::User::documents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.documents#findById
             * @methodOf lbServices.User.documents
             *
             * @description
             *
             * Find a related item by id for documents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for documents
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
        R.documents.findById = function() {
          var TargetResource = $injector.get("Document");
          var action = TargetResource["::findById::User::documents"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.documents#updateById
             * @methodOf lbServices.User.documents
             *
             * @description
             *
             * Update a related item by id for documents.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for documents
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
        R.documents.updateById = function() {
          var TargetResource = $injector.get("Document");
          var action = TargetResource["::updateById::User::documents"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.sessionParticipants
     * @header lbServices.User.sessionParticipants
     * @object
     * @description
     *
     * The object `User.sessionParticipants` groups methods
     * manipulating `SessionParticipant` instances related to `User`.
     *
     * Call {@link lbServices.User#sessionParticipants User.sessionParticipants()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#sessionParticipants
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries sessionParticipants of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SessionParticipant` object.)
             * </em>
             */
        R.sessionParticipants = function() {
          var TargetResource = $injector.get("SessionParticipant");
          var action = TargetResource["::get::User::sessionParticipants"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.sessionParticipants#count
             * @methodOf lbServices.User.sessionParticipants
             *
             * @description
             *
             * Counts sessionParticipants of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.sessionParticipants.count = function() {
          var TargetResource = $injector.get("SessionParticipant");
          var action = TargetResource["::count::User::sessionParticipants"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.sessionParticipants#create
             * @methodOf lbServices.User.sessionParticipants
             *
             * @description
             *
             * Creates a new instance in sessionParticipants of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SessionParticipant` object.)
             * </em>
             */
        R.sessionParticipants.create = function() {
          var TargetResource = $injector.get("SessionParticipant");
          var action = TargetResource["::create::User::sessionParticipants"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.sessionParticipants#createMany
             * @methodOf lbServices.User.sessionParticipants
             *
             * @description
             *
             * Creates a new instance in sessionParticipants of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SessionParticipant` object.)
             * </em>
             */
        R.sessionParticipants.createMany = function() {
          var TargetResource = $injector.get("SessionParticipant");
          var action = TargetResource["::createMany::User::sessionParticipants"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.sessionParticipants#findById
             * @methodOf lbServices.User.sessionParticipants
             *
             * @description
             *
             * Find a related item by id for sessionParticipants.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for sessionParticipants
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SessionParticipant` object.)
             * </em>
             */
        R.sessionParticipants.findById = function() {
          var TargetResource = $injector.get("SessionParticipant");
          var action = TargetResource["::findById::User::sessionParticipants"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.sessionParticipants#updateById
             * @methodOf lbServices.User.sessionParticipants
             *
             * @description
             *
             * Update a related item by id for sessionParticipants.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for sessionParticipants
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SessionParticipant` object.)
             * </em>
             */
        R.sessionParticipants.updateById = function() {
          var TargetResource = $injector.get("SessionParticipant");
          var action = TargetResource["::updateById::User::sessionParticipants"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.legals
     * @header lbServices.User.legals
     * @object
     * @description
     *
     * The object `User.legals` groups methods
     * manipulating `Legal` instances related to `User`.
     *
     * Call {@link lbServices.User#legals User.legals()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#legals
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries legals of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Legal` object.)
             * </em>
             */
        R.legals = function() {
          var TargetResource = $injector.get("Legal");
          var action = TargetResource["::get::User::legals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.legals#create
             * @methodOf lbServices.User.legals
             *
             * @description
             *
             * Creates a new instance in legals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Legal` object.)
             * </em>
             */
        R.legals.create = function() {
          var TargetResource = $injector.get("Legal");
          var action = TargetResource["::create::User::legals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.legals#createMany
             * @methodOf lbServices.User.legals
             *
             * @description
             *
             * Creates a new instance in legals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Legal` object.)
             * </em>
             */
        R.legals.createMany = function() {
          var TargetResource = $injector.get("Legal");
          var action = TargetResource["::createMany::User::legals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.legals#destroyById
             * @methodOf lbServices.User.legals
             *
             * @description
             *
             * Delete a related item by id for legals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for legals
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.legals.destroyById = function() {
          var TargetResource = $injector.get("Legal");
          var action = TargetResource["::destroyById::User::legals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.legals#updateById
             * @methodOf lbServices.User.legals
             *
             * @description
             *
             * Update a related item by id for legals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for legals
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Legal` object.)
             * </em>
             */
        R.legals.updateById = function() {
          var TargetResource = $injector.get("Legal");
          var action = TargetResource["::updateById::User::legals"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.locationsLicenced
     * @header lbServices.User.locationsLicenced
     * @object
     * @description
     *
     * The object `User.locationsLicenced` groups methods
     * manipulating `LocationLicenced` instances related to `User`.
     *
     * Call {@link lbServices.User#locationsLicenced User.locationsLicenced()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#locationsLicenced
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries locationsLicenced of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LocationLicenced` object.)
             * </em>
             */
        R.locationsLicenced = function() {
          var TargetResource = $injector.get("LocationLicenced");
          var action = TargetResource["::get::User::locationsLicenced"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.locationsLicenced#count
             * @methodOf lbServices.User.locationsLicenced
             *
             * @description
             *
             * Counts locationsLicenced of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.locationsLicenced.count = function() {
          var TargetResource = $injector.get("LocationLicenced");
          var action = TargetResource["::count::User::locationsLicenced"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.locationsLicenced#create
             * @methodOf lbServices.User.locationsLicenced
             *
             * @description
             *
             * Creates a new instance in locationsLicenced of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LocationLicenced` object.)
             * </em>
             */
        R.locationsLicenced.create = function() {
          var TargetResource = $injector.get("LocationLicenced");
          var action = TargetResource["::create::User::locationsLicenced"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.locationsLicenced#createMany
             * @methodOf lbServices.User.locationsLicenced
             *
             * @description
             *
             * Creates a new instance in locationsLicenced of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LocationLicenced` object.)
             * </em>
             */
        R.locationsLicenced.createMany = function() {
          var TargetResource = $injector.get("LocationLicenced");
          var action = TargetResource["::createMany::User::locationsLicenced"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.locationsLicenced#destroyAll
             * @methodOf lbServices.User.locationsLicenced
             *
             * @description
             *
             * Deletes all locationsLicenced of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.locationsLicenced.destroyAll = function() {
          var TargetResource = $injector.get("LocationLicenced");
          var action = TargetResource["::delete::User::locationsLicenced"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.locationsLicenced#destroyById
             * @methodOf lbServices.User.locationsLicenced
             *
             * @description
             *
             * Delete a related item by id for locationsLicenced.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for locationsLicenced
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.locationsLicenced.destroyById = function() {
          var TargetResource = $injector.get("LocationLicenced");
          var action = TargetResource["::destroyById::User::locationsLicenced"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.locationsLicenced#findById
             * @methodOf lbServices.User.locationsLicenced
             *
             * @description
             *
             * Find a related item by id for locationsLicenced.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for locationsLicenced
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LocationLicenced` object.)
             * </em>
             */
        R.locationsLicenced.findById = function() {
          var TargetResource = $injector.get("LocationLicenced");
          var action = TargetResource["::findById::User::locationsLicenced"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.locationsLicenced#updateById
             * @methodOf lbServices.User.locationsLicenced
             *
             * @description
             *
             * Update a related item by id for locationsLicenced.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for locationsLicenced
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LocationLicenced` object.)
             * </em>
             */
        R.locationsLicenced.updateById = function() {
          var TargetResource = $injector.get("LocationLicenced");
          var action = TargetResource["::updateById::User::locationsLicenced"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.institutions
     * @header lbServices.User.institutions
     * @object
     * @description
     *
     * The object `User.institutions` groups methods
     * manipulating `Institution` instances related to `User`.
     *
     * Call {@link lbServices.User#institutions User.institutions()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#institutions
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries institutions of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
        R.institutions = function() {
          var TargetResource = $injector.get("Institution");
          var action = TargetResource["::get::User::institutions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.institutions#findById
             * @methodOf lbServices.User.institutions
             *
             * @description
             *
             * Find a related item by id for institutions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for institutions
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
        R.institutions.findById = function() {
          var TargetResource = $injector.get("Institution");
          var action = TargetResource["::findById::User::institutions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.institutions#link
             * @methodOf lbServices.User.institutions
             *
             * @description
             *
             * Add a related item by id for institutions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for institutions
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
        R.institutions.link = function() {
          var TargetResource = $injector.get("Institution");
          var action = TargetResource["::link::User::institutions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.institutions#unlink
             * @methodOf lbServices.User.institutions
             *
             * @description
             *
             * Remove the institutions relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for institutions
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.institutions.unlink = function() {
          var TargetResource = $injector.get("Institution");
          var action = TargetResource["::unlink::User::institutions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.institutions#updateById
             * @methodOf lbServices.User.institutions
             *
             * @description
             *
             * Update a related item by id for institutions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for institutions
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
        R.institutions.updateById = function() {
          var TargetResource = $injector.get("Institution");
          var action = TargetResource["::updateById::User::institutions"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.rooms
     * @header lbServices.User.rooms
     * @object
     * @description
     *
     * The object `User.rooms` groups methods
     * manipulating `Room` instances related to `User`.
     *
     * Call {@link lbServices.User#rooms User.rooms()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#rooms
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries rooms of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
        R.rooms = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::get::User::rooms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.rooms#create
             * @methodOf lbServices.User.rooms
             *
             * @description
             *
             * Creates a new instance in rooms of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
        R.rooms.create = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::create::User::rooms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.rooms#createMany
             * @methodOf lbServices.User.rooms
             *
             * @description
             *
             * Creates a new instance in rooms of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
        R.rooms.createMany = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::createMany::User::rooms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.rooms#exists
             * @methodOf lbServices.User.rooms
             *
             * @description
             *
             * Check the existence of rooms relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for rooms
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
        R.rooms.exists = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::exists::User::rooms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.rooms#findById
             * @methodOf lbServices.User.rooms
             *
             * @description
             *
             * Find a related item by id for rooms.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for rooms
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
        R.rooms.findById = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::findById::User::rooms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.rooms#link
             * @methodOf lbServices.User.rooms
             *
             * @description
             *
             * Add a related item by id for rooms.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for rooms
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
        R.rooms.link = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::link::User::rooms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.rooms#unlink
             * @methodOf lbServices.User.rooms
             *
             * @description
             *
             * Remove the rooms relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for rooms
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.rooms.unlink = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::unlink::User::rooms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.rooms#updateById
             * @methodOf lbServices.User.rooms
             *
             * @description
             *
             * Update a related item by id for rooms.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for rooms
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Room` object.)
             * </em>
             */
        R.rooms.updateById = function() {
          var TargetResource = $injector.get("Room");
          var action = TargetResource["::updateById::User::rooms"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.roomsMemberships
     * @header lbServices.User.roomsMemberships
     * @object
     * @description
     *
     * The object `User.roomsMemberships` groups methods
     * manipulating `RoomMember` instances related to `User`.
     *
     * Call {@link lbServices.User#roomsMemberships User.roomsMemberships()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#roomsMemberships
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries roomsMemberships of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoomMember` object.)
             * </em>
             */
        R.roomsMemberships = function() {
          var TargetResource = $injector.get("RoomMember");
          var action = TargetResource["::get::User::roomsMemberships"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roomsMemberships#count
             * @methodOf lbServices.User.roomsMemberships
             *
             * @description
             *
             * Counts roomsMemberships of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.roomsMemberships.count = function() {
          var TargetResource = $injector.get("RoomMember");
          var action = TargetResource["::count::User::roomsMemberships"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roomsMemberships#create
             * @methodOf lbServices.User.roomsMemberships
             *
             * @description
             *
             * Creates a new instance in roomsMemberships of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoomMember` object.)
             * </em>
             */
        R.roomsMemberships.create = function() {
          var TargetResource = $injector.get("RoomMember");
          var action = TargetResource["::create::User::roomsMemberships"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roomsMemberships#createMany
             * @methodOf lbServices.User.roomsMemberships
             *
             * @description
             *
             * Creates a new instance in roomsMemberships of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoomMember` object.)
             * </em>
             */
        R.roomsMemberships.createMany = function() {
          var TargetResource = $injector.get("RoomMember");
          var action = TargetResource["::createMany::User::roomsMemberships"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roomsMemberships#destroyAll
             * @methodOf lbServices.User.roomsMemberships
             *
             * @description
             *
             * Deletes all roomsMemberships of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.roomsMemberships.destroyAll = function() {
          var TargetResource = $injector.get("RoomMember");
          var action = TargetResource["::delete::User::roomsMemberships"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roomsMemberships#destroyById
             * @methodOf lbServices.User.roomsMemberships
             *
             * @description
             *
             * Delete a related item by id for roomsMemberships.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for roomsMemberships
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.roomsMemberships.destroyById = function() {
          var TargetResource = $injector.get("RoomMember");
          var action = TargetResource["::destroyById::User::roomsMemberships"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roomsMemberships#findById
             * @methodOf lbServices.User.roomsMemberships
             *
             * @description
             *
             * Find a related item by id for roomsMemberships.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for roomsMemberships
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoomMember` object.)
             * </em>
             */
        R.roomsMemberships.findById = function() {
          var TargetResource = $injector.get("RoomMember");
          var action = TargetResource["::findById::User::roomsMemberships"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.roomsMemberships#updateById
             * @methodOf lbServices.User.roomsMemberships
             *
             * @description
             *
             * Update a related item by id for roomsMemberships.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for roomsMemberships
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoomMember` object.)
             * </em>
             */
        R.roomsMemberships.updateById = function() {
          var TargetResource = $injector.get("RoomMember");
          var action = TargetResource["::updateById::User::roomsMemberships"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.purchases
     * @header lbServices.User.purchases
     * @object
     * @description
     *
     * The object `User.purchases` groups methods
     * manipulating `Purchase` instances related to `User`.
     *
     * Call {@link lbServices.User#purchases User.purchases()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#purchases
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries purchases of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
        R.purchases = function() {
          var TargetResource = $injector.get("Purchase");
          var action = TargetResource["::get::User::purchases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.purchases#count
             * @methodOf lbServices.User.purchases
             *
             * @description
             *
             * Counts purchases of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.purchases.count = function() {
          var TargetResource = $injector.get("Purchase");
          var action = TargetResource["::count::User::purchases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.purchases#findById
             * @methodOf lbServices.User.purchases
             *
             * @description
             *
             * Find a related item by id for purchases.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for purchases
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
        R.purchases.findById = function() {
          var TargetResource = $injector.get("Purchase");
          var action = TargetResource["::findById::User::purchases"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.identities
     * @header lbServices.User.identities
     * @object
     * @description
     *
     * The object `User.identities` groups methods
     * manipulating `UserIdentity` instances related to `User`.
     *
     * Call {@link lbServices.User#identities User.identities()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#identities
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries identities of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
        R.identities = function() {
          var TargetResource = $injector.get("UserIdentity");
          var action = TargetResource["::get::User::identities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.identities#count
             * @methodOf lbServices.User.identities
             *
             * @description
             *
             * Counts identities of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.identities.count = function() {
          var TargetResource = $injector.get("UserIdentity");
          var action = TargetResource["::count::User::identities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.identities#create
             * @methodOf lbServices.User.identities
             *
             * @description
             *
             * Creates a new instance in identities of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
        R.identities.create = function() {
          var TargetResource = $injector.get("UserIdentity");
          var action = TargetResource["::create::User::identities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.identities#createMany
             * @methodOf lbServices.User.identities
             *
             * @description
             *
             * Creates a new instance in identities of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
        R.identities.createMany = function() {
          var TargetResource = $injector.get("UserIdentity");
          var action = TargetResource["::createMany::User::identities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.identities#destroyAll
             * @methodOf lbServices.User.identities
             *
             * @description
             *
             * Deletes all identities of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.identities.destroyAll = function() {
          var TargetResource = $injector.get("UserIdentity");
          var action = TargetResource["::delete::User::identities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.identities#destroyById
             * @methodOf lbServices.User.identities
             *
             * @description
             *
             * Delete a related item by id for identities.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for identities
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.identities.destroyById = function() {
          var TargetResource = $injector.get("UserIdentity");
          var action = TargetResource["::destroyById::User::identities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.identities#findById
             * @methodOf lbServices.User.identities
             *
             * @description
             *
             * Find a related item by id for identities.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for identities
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
        R.identities.findById = function() {
          var TargetResource = $injector.get("UserIdentity");
          var action = TargetResource["::findById::User::identities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.identities#updateById
             * @methodOf lbServices.User.identities
             *
             * @description
             *
             * Update a related item by id for identities.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for identities
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
        R.identities.updateById = function() {
          var TargetResource = $injector.get("UserIdentity");
          var action = TargetResource["::updateById::User::identities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User#accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries accessTokens of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessToken` object.)
             * </em>
             */
        R.accessTokens = function() {
          var TargetResource = $injector.get("AccessToken");
          var action = TargetResource["::get::User::accessTokens"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Legal
 * @header lbServices.Legal
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Legal` model.
 *
 * **Details**
 *
 * Keep data related to BAA for both institution and users
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Legal",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/legals/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Legal#replaceOrCreate
             * @methodOf lbServices.Legal
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Legal` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/legals/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Legal#upsertWithWhere
             * @methodOf lbServices.Legal
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Legal` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/legals/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Legal#replaceById
             * @methodOf lbServices.Legal
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Legal` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/legals/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Legal#prototype$deleteBaa
             * @methodOf lbServices.Legal
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - legal id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$deleteBaa": {
              url: urlBase + "/legals/:id/deleteBaa",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Legal#createBaa
             * @methodOf lbServices.Legal
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `legalData` – `{object}` -
             *
             *  - `req` – `{undefined=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "createBaa": {
              url: urlBase + "/legals/createBaa",
              method: "POST",
            },

            // INTERNAL. Use User.legals.destroyById() instead.
            "::destroyById::User::legals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/legals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.legals.updateById() instead.
            "::updateById::User::legals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/legals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.legals() instead.
            "::get::User::legals": {
              isArray: true,
              url: urlBase + "/users/:id/legals",
              method: "GET",
            },

            // INTERNAL. Use User.legals.create() instead.
            "::create::User::legals": {
              url: urlBase + "/users/:id/legals",
              method: "POST",
            },

            // INTERNAL. Use User.legals.createMany() instead.
            "::createMany::User::legals": {
              isArray: true,
              url: urlBase + "/users/:id/legals",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Legal#patchOrCreateWithWhere
             * @methodOf lbServices.Legal
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Legal` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];


        /**
        * @ngdoc property
        * @name lbServices.Legal#modelName
        * @propertyOf lbServices.Legal
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Legal`.
        */
        R.modelName = "Legal";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.LocationLicenced
 * @header lbServices.LocationLicenced
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `LocationLicenced` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "LocationLicenced",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/locationLicenceds/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.LocationLicenced#replaceOrCreate
             * @methodOf lbServices.LocationLicenced
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LocationLicenced` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/locationLicenceds/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LocationLicenced#upsertWithWhere
             * @methodOf lbServices.LocationLicenced
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LocationLicenced` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/locationLicenceds/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LocationLicenced#replaceById
             * @methodOf lbServices.LocationLicenced
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LocationLicenced` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/locationLicenceds/:id/replace",
              method: "POST",
            },

            // INTERNAL. Use User.locationsLicenced.findById() instead.
            "::findById::User::locationsLicenced": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/locationsLicenced/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.locationsLicenced.destroyById() instead.
            "::destroyById::User::locationsLicenced": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/locationsLicenced/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.locationsLicenced.updateById() instead.
            "::updateById::User::locationsLicenced": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/locationsLicenced/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.locationsLicenced() instead.
            "::get::User::locationsLicenced": {
              isArray: true,
              url: urlBase + "/users/:id/locationsLicenced",
              method: "GET",
            },

            // INTERNAL. Use User.locationsLicenced.create() instead.
            "::create::User::locationsLicenced": {
              url: urlBase + "/users/:id/locationsLicenced",
              method: "POST",
            },

            // INTERNAL. Use User.locationsLicenced.createMany() instead.
            "::createMany::User::locationsLicenced": {
              isArray: true,
              url: urlBase + "/users/:id/locationsLicenced",
              method: "POST",
            },

            // INTERNAL. Use User.locationsLicenced.destroyAll() instead.
            "::delete::User::locationsLicenced": {
              url: urlBase + "/users/:id/locationsLicenced",
              method: "DELETE",
            },

            // INTERNAL. Use User.locationsLicenced.count() instead.
            "::count::User::locationsLicenced": {
              url: urlBase + "/users/:id/locationsLicenced/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.LocationLicenced#patchOrCreateWithWhere
             * @methodOf lbServices.LocationLicenced
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LocationLicenced` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];


        /**
        * @ngdoc property
        * @name lbServices.LocationLicenced#modelName
        * @propertyOf lbServices.LocationLicenced
        * @description
        * The name of the model represented by this $resource,
        * i.e. `LocationLicenced`.
        */
        R.modelName = "LocationLicenced";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.InviteToken
 * @header lbServices.InviteToken
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `InviteToken` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "InviteToken",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/inviteTokens/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.InviteToken#replaceOrCreate
             * @methodOf lbServices.InviteToken
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InviteToken` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/inviteTokens/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InviteToken#upsertWithWhere
             * @methodOf lbServices.InviteToken
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InviteToken` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/inviteTokens/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InviteToken#findById
             * @methodOf lbServices.InviteToken
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InviteToken` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/inviteTokens/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InviteToken#replaceById
             * @methodOf lbServices.InviteToken
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InviteToken` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/inviteTokens/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InviteToken#findByToken
             * @methodOf lbServices.InviteToken
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `token` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InviteToken` object.)
             * </em>
             */
            "findByToken": {
              url: urlBase + "/inviteTokens/findByToken",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InviteToken#deletePendingUsers
             * @methodOf lbServices.InviteToken
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `targetId` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InviteToken` object.)
             * </em>
             */
            "deletePendingUsers": {
              url: urlBase + "/inviteTokens/deletePendingUsers",
              method: "DELETE",
            },

            // INTERNAL. Use Institution.inviteTokens.findById() instead.
            "::findById::Institution::inviteTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/institutions/:id/inviteTokens/:fk",
              method: "GET",
            },

            // INTERNAL. Use Institution.inviteTokens.destroyById() instead.
            "::destroyById::Institution::inviteTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/institutions/:id/inviteTokens/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Institution.inviteTokens() instead.
            "::get::Institution::inviteTokens": {
              isArray: true,
              url: urlBase + "/institutions/:id/inviteTokens",
              method: "GET",
            },

            // INTERNAL. Use Institution.inviteTokens.create() instead.
            "::create::Institution::inviteTokens": {
              url: urlBase + "/institutions/:id/inviteTokens",
              method: "POST",
            },

            // INTERNAL. Use Institution.inviteTokens.createMany() instead.
            "::createMany::Institution::inviteTokens": {
              isArray: true,
              url: urlBase + "/institutions/:id/inviteTokens",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.InviteToken#patchOrCreateWithWhere
             * @methodOf lbServices.InviteToken
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InviteToken` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];


        /**
        * @ngdoc property
        * @name lbServices.InviteToken#modelName
        * @propertyOf lbServices.InviteToken
        * @description
        * The name of the model represented by this $resource,
        * i.e. `InviteToken`.
        */
        R.modelName = "InviteToken";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.InstitutionMember
 * @header lbServices.InstitutionMember
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `InstitutionMember` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "InstitutionMember",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/institutionMembers/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use InstitutionMember.institutionLocation() instead.
            "prototype$__get__institutionLocation": {
              url: urlBase + "/institutionMembers/:id/institutionLocation",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionMember#upsert
             * @methodOf lbServices.InstitutionMember
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionMember` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/institutionMembers",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionMember#replaceOrCreate
             * @methodOf lbServices.InstitutionMember
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionMember` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/institutionMembers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionMember#upsertWithWhere
             * @methodOf lbServices.InstitutionMember
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionMember` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/institutionMembers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionMember#replaceById
             * @methodOf lbServices.InstitutionMember
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionMember` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/institutionMembers/:id/replace",
              method: "POST",
            },

            // INTERNAL. Use Institution.institutionMemberships.updateById() instead.
            "::updateById::Institution::institutionMemberships": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/institutions/:id/institutionMemberships/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Institution.institutionMemberships() instead.
            "::get::Institution::institutionMemberships": {
              isArray: true,
              url: urlBase + "/institutions/:id/institutionMemberships",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.InstitutionMember#patchOrCreate
             * @methodOf lbServices.InstitutionMember
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionMember` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.InstitutionMember#updateOrCreate
             * @methodOf lbServices.InstitutionMember
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionMember` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.InstitutionMember#patchOrCreateWithWhere
             * @methodOf lbServices.InstitutionMember
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionMember` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];


        /**
        * @ngdoc property
        * @name lbServices.InstitutionMember#modelName
        * @propertyOf lbServices.InstitutionMember
        * @description
        * The name of the model represented by this $resource,
        * i.e. `InstitutionMember`.
        */
        R.modelName = "InstitutionMember";


            /**
             * @ngdoc method
             * @name lbServices.InstitutionMember#institutionLocation
             * @methodOf lbServices.InstitutionMember
             *
             * @description
             *
             * Fetches belongsTo relation institutionLocation.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institutionMember id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionLocation` object.)
             * </em>
             */
        R.institutionLocation = function() {
          var TargetResource = $injector.get("InstitutionLocation");
          var action = TargetResource["::get::InstitutionMember::institutionLocation"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.RoomMember
 * @header lbServices.RoomMember
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `RoomMember` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "RoomMember",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/roomMembers/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.RoomMember#replaceOrCreate
             * @methodOf lbServices.RoomMember
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoomMember` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/roomMembers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoomMember#upsertWithWhere
             * @methodOf lbServices.RoomMember
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoomMember` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/roomMembers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RoomMember#replaceById
             * @methodOf lbServices.RoomMember
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoomMember` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/roomMembers/:id/replace",
              method: "POST",
            },

            // INTERNAL. Use Room.roomMemberships.destroyById() instead.
            "::destroyById::Room::roomMemberships": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/rooms/:id/roomMemberships/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Room.roomMemberships.updateById() instead.
            "::updateById::Room::roomMemberships": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/rooms/:id/roomMemberships/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Room.roomMemberships() instead.
            "::get::Room::roomMemberships": {
              isArray: true,
              url: urlBase + "/rooms/:id/roomMemberships",
              method: "GET",
            },

            // INTERNAL. Use Room.roomMemberships.create() instead.
            "::create::Room::roomMemberships": {
              url: urlBase + "/rooms/:id/roomMemberships",
              method: "POST",
            },

            // INTERNAL. Use Room.roomMemberships.createMany() instead.
            "::createMany::Room::roomMemberships": {
              isArray: true,
              url: urlBase + "/rooms/:id/roomMemberships",
              method: "POST",
            },

            // INTERNAL. Use User.roomsMemberships.findById() instead.
            "::findById::User::roomsMemberships": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roomsMemberships/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.roomsMemberships.destroyById() instead.
            "::destroyById::User::roomsMemberships": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roomsMemberships/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.roomsMemberships.updateById() instead.
            "::updateById::User::roomsMemberships": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/roomsMemberships/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.roomsMemberships() instead.
            "::get::User::roomsMemberships": {
              isArray: true,
              url: urlBase + "/users/:id/roomsMemberships",
              method: "GET",
            },

            // INTERNAL. Use User.roomsMemberships.create() instead.
            "::create::User::roomsMemberships": {
              url: urlBase + "/users/:id/roomsMemberships",
              method: "POST",
            },

            // INTERNAL. Use User.roomsMemberships.createMany() instead.
            "::createMany::User::roomsMemberships": {
              isArray: true,
              url: urlBase + "/users/:id/roomsMemberships",
              method: "POST",
            },

            // INTERNAL. Use User.roomsMemberships.destroyAll() instead.
            "::delete::User::roomsMemberships": {
              url: urlBase + "/users/:id/roomsMemberships",
              method: "DELETE",
            },

            // INTERNAL. Use User.roomsMemberships.count() instead.
            "::count::User::roomsMemberships": {
              url: urlBase + "/users/:id/roomsMemberships/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.RoomMember#patchOrCreateWithWhere
             * @methodOf lbServices.RoomMember
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RoomMember` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];


        /**
        * @ngdoc property
        * @name lbServices.RoomMember#modelName
        * @propertyOf lbServices.RoomMember
        * @description
        * The name of the model represented by this $resource,
        * i.e. `RoomMember`.
        */
        R.modelName = "RoomMember";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Purchase
 * @header lbServices.Purchase
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Purchase` model.
 *
 * **Details**
 *
 * Joins user with plans that they bought
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Purchase",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/purchases/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Purchase.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/purchases/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Purchase.institution() instead.
            "prototype$__get__institution": {
              url: urlBase + "/purchases/:id/institution",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#create
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/purchases",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#createMany
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/purchases",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#replaceOrCreate
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/purchases/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#upsertWithWhere
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/purchases/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#exists
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/purchases/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#findById
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/purchases/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#replaceById
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/purchases/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#find
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/purchases",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#count
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/purchases/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#prototype$updateAttributes
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - purchase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/purchases/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#webhook
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{undefined=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "webhook": {
              url: urlBase + "/purchases/webhook",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#getPlans
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "getPlans": {
              isArray: true,
              url: urlBase + "/purchases/plans",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#validateCoupon
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `code` – `{string}` -
             *
             *  - `currency` – `{string}` -
             *
             *  - `product` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "validateCoupon": {
              url: urlBase + "/purchases/validateCoupon",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#completePurchase
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `paymentIntentId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "completePurchase": {
              url: urlBase + "/purchases/completePurchase",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#prototype$cancel
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - purchase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `cancelNow` – `{boolean=}` -
             *
             *  - `comment` – `{string=}` -
             *
             *  - `reason` – `{string=}` -
             *
             *  - `ctx` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$cancel": {
              url: urlBase + "/purchases/:id/cancel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#prototype$getSubscription
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - purchase id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "prototype$getSubscription": {
              url: urlBase + "/purchases/:id/getSubscription",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#prototype$preview
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - purchase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `req` – `{}` -
             *
             *  - `planId` – `{string=}` -
             *
             *  - `seats` – `{number=}` -
             *
             *  - `coupon` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "prototype$preview": {
              url: urlBase + "/purchases/:id/preview",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#prototype$previewCostPerSeat
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - purchase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `planId` – `{string=}` -
             *
             *  - `seats` – `{number=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "prototype$previewCostPerSeat": {
              url: urlBase + "/purchases/:id/previewCostPerSeat",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#prototype$adminUpdate
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - purchase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `stripeId` – `{string=}` -
             *
             *  - `isActive` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "prototype$adminUpdate": {
              url: urlBase + "/purchases/:id/admin-update",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#addDowngradeDiscount
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "addDowngradeDiscount": {
              url: urlBase + "/purchases/admin-update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#prototype$forceSync
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Update subscription metadata (plan id, seats, interval) from stripe. It's useful when we have a mismatch between stripe and our database
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method does not accept any data. Supply an empty object.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "prototype$forceSync": {
              url: urlBase + "/purchases/:id/forceSync",
              method: "POST",
            },

            // INTERNAL. Use Institution.purchases.findById() instead.
            "::findById::Institution::purchases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/institutions/:id/purchases/:fk",
              method: "GET",
            },

            // INTERNAL. Use Institution.purchases() instead.
            "::get::Institution::purchases": {
              isArray: true,
              url: urlBase + "/institutions/:id/purchases",
              method: "GET",
            },

            // INTERNAL. Use User.purchases.findById() instead.
            "::findById::User::purchases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/purchases/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.purchases() instead.
            "::get::User::purchases": {
              isArray: true,
              url: urlBase + "/users/:id/purchases",
              method: "GET",
            },

            // INTERNAL. Use User.purchases.count() instead.
            "::count::User::purchases": {
              url: urlBase + "/users/:id/purchases/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Purchase#patchOrCreateWithWhere
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Purchase#patchAttributes
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - purchase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Purchase#modelName
        * @propertyOf lbServices.Purchase
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Purchase`.
        */
        R.modelName = "Purchase";


            /**
             * @ngdoc method
             * @name lbServices.Purchase#user
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Purchase::user"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase#institution
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Fetches belongsTo relation institution.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
        R.institution = function() {
          var TargetResource = $injector.get("Institution");
          var action = TargetResource["::get::Purchase::institution"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.BetaAccess
 * @header lbServices.BetaAccess
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `BetaAccess` model.
 *
 * **Details**
 *
 * Keep info about beta access to features for user and institution
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "BetaAccess",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/betaAccesses/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.BetaAccess#create
             * @methodOf lbServices.BetaAccess
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BetaAccess` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/betaAccesses",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BetaAccess#createMany
             * @methodOf lbServices.BetaAccess
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BetaAccess` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/betaAccesses",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BetaAccess#replaceOrCreate
             * @methodOf lbServices.BetaAccess
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BetaAccess` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/betaAccesses/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BetaAccess#upsertWithWhere
             * @methodOf lbServices.BetaAccess
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BetaAccess` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/betaAccesses/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BetaAccess#findById
             * @methodOf lbServices.BetaAccess
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BetaAccess` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/betaAccesses/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BetaAccess#replaceById
             * @methodOf lbServices.BetaAccess
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BetaAccess` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/betaAccesses/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BetaAccess#find
             * @methodOf lbServices.BetaAccess
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BetaAccess` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/betaAccesses",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BetaAccess#findOne
             * @methodOf lbServices.BetaAccess
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BetaAccess` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/betaAccesses/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BetaAccess#deleteById
             * @methodOf lbServices.BetaAccess
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BetaAccess` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/betaAccesses/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.BetaAccess#count
             * @methodOf lbServices.BetaAccess
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/betaAccesses/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BetaAccess#removeFeatureForUsers
             * @methodOf lbServices.BetaAccess
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `feature` – `{string}` -
             *
             *  - `userIds` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BetaAccess` object.)
             * </em>
             */
            "removeFeatureForUsers": {
              url: urlBase + "/betaAccesses/removeFeatureForUsers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BetaAccess#removeFeatureForInstitutions
             * @methodOf lbServices.BetaAccess
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `feature` – `{string}` -
             *
             *  - `institutionIds` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BetaAccess` object.)
             * </em>
             */
            "removeFeatureForInstitutions": {
              url: urlBase + "/betaAccesses/removeFeatureForInstitutions",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BetaAccess#getBetaAccesses
             * @methodOf lbServices.BetaAccess
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{undefined=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BetaAccess` object.)
             * </em>
             */
            "getBetaAccesses": {
              url: urlBase + "/betaAccesses/getBetaAccesses",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.BetaAccess#patchOrCreateWithWhere
             * @methodOf lbServices.BetaAccess
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BetaAccess` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.BetaAccess#destroyById
             * @methodOf lbServices.BetaAccess
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BetaAccess` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.BetaAccess#removeById
             * @methodOf lbServices.BetaAccess
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BetaAccess` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];


        /**
        * @ngdoc property
        * @name lbServices.BetaAccess#modelName
        * @propertyOf lbServices.BetaAccess
        * @description
        * The name of the model represented by this $resource,
        * i.e. `BetaAccess`.
        */
        R.modelName = "BetaAccess";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.UserIdentity
 * @header lbServices.UserIdentity
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `UserIdentity` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "UserIdentity",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/userIdentities/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use UserIdentity.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/userIdentities/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#create
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/userIdentities",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#createMany
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/userIdentities",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#upsert
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/userIdentities",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#replaceOrCreate
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/userIdentities/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#upsertWithWhere
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/userIdentities/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#exists
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/userIdentities/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#findById
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/userIdentities/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#replaceById
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/userIdentities/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#find
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/userIdentities",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#findOne
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/userIdentities/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#updateAll
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/userIdentities/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#deleteById
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/userIdentities/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#count
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/userIdentities/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#prototype$updateAttributes
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - userIdentity id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/userIdentities/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#createChangeStream
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/userIdentities/change-stream",
              method: "POST",
            },

            // INTERNAL. Use User.identities.findById() instead.
            "::findById::User::identities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/identities/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.identities.destroyById() instead.
            "::destroyById::User::identities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/identities/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.identities.updateById() instead.
            "::updateById::User::identities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/identities/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.identities() instead.
            "::get::User::identities": {
              isArray: true,
              url: urlBase + "/users/:id/identities",
              method: "GET",
            },

            // INTERNAL. Use User.identities.create() instead.
            "::create::User::identities": {
              url: urlBase + "/users/:id/identities",
              method: "POST",
            },

            // INTERNAL. Use User.identities.createMany() instead.
            "::createMany::User::identities": {
              isArray: true,
              url: urlBase + "/users/:id/identities",
              method: "POST",
            },

            // INTERNAL. Use User.identities.destroyAll() instead.
            "::delete::User::identities": {
              url: urlBase + "/users/:id/identities",
              method: "DELETE",
            },

            // INTERNAL. Use User.identities.count() instead.
            "::count::User::identities": {
              url: urlBase + "/users/:id/identities/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#patchOrCreate
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#updateOrCreate
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#patchOrCreateWithWhere
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#update
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#destroyById
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#removeById
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#patchAttributes
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - userIdentity id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserIdentity` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.UserIdentity#modelName
        * @propertyOf lbServices.UserIdentity
        * @description
        * The name of the model represented by this $resource,
        * i.e. `UserIdentity`.
        */
        R.modelName = "UserIdentity";


            /**
             * @ngdoc method
             * @name lbServices.UserIdentity#user
             * @methodOf lbServices.UserIdentity
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - userIdentity id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::UserIdentity::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.InstitutionSettings
 * @header lbServices.InstitutionSettings
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `InstitutionSettings` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "InstitutionSettings",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/institutionSettings/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use InstitutionSettings.institution() instead.
            "prototype$__get__institution": {
              url: urlBase + "/institutionSettings/:id/institution",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionSettings#create
             * @methodOf lbServices.InstitutionSettings
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionSettings` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/institutionSettings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionSettings#createMany
             * @methodOf lbServices.InstitutionSettings
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionSettings` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/institutionSettings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionSettings#upsert
             * @methodOf lbServices.InstitutionSettings
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionSettings` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/institutionSettings",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionSettings#replaceOrCreate
             * @methodOf lbServices.InstitutionSettings
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionSettings` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/institutionSettings/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionSettings#upsertWithWhere
             * @methodOf lbServices.InstitutionSettings
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionSettings` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/institutionSettings/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionSettings#exists
             * @methodOf lbServices.InstitutionSettings
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/institutionSettings/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionSettings#findById
             * @methodOf lbServices.InstitutionSettings
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionSettings` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/institutionSettings/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionSettings#replaceById
             * @methodOf lbServices.InstitutionSettings
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionSettings` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/institutionSettings/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionSettings#find
             * @methodOf lbServices.InstitutionSettings
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionSettings` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/institutionSettings",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionSettings#findOne
             * @methodOf lbServices.InstitutionSettings
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionSettings` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/institutionSettings/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionSettings#updateAll
             * @methodOf lbServices.InstitutionSettings
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/institutionSettings/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionSettings#deleteById
             * @methodOf lbServices.InstitutionSettings
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionSettings` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/institutionSettings/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionSettings#count
             * @methodOf lbServices.InstitutionSettings
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/institutionSettings/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionSettings#prototype$updateAttributes
             * @methodOf lbServices.InstitutionSettings
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institutionSettings id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionSettings` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/institutionSettings/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionSettings#createChangeStream
             * @methodOf lbServices.InstitutionSettings
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/institutionSettings/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Institution.settings() instead.
            "::get::Institution::settings": {
              url: urlBase + "/institutions/:id/settings",
              method: "GET",
            },

            // INTERNAL. Use Institution.settings.create() instead.
            "::create::Institution::settings": {
              url: urlBase + "/institutions/:id/settings",
              method: "POST",
            },

            // INTERNAL. Use Institution.settings.createMany() instead.
            "::createMany::Institution::settings": {
              isArray: true,
              url: urlBase + "/institutions/:id/settings",
              method: "POST",
            },

            // INTERNAL. Use Institution.settings.update() instead.
            "::update::Institution::settings": {
              url: urlBase + "/institutions/:id/settings",
              method: "PUT",
            },

            // INTERNAL. Use Institution.settings.destroy() instead.
            "::destroy::Institution::settings": {
              url: urlBase + "/institutions/:id/settings",
              method: "DELETE",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.InstitutionSettings#patchOrCreate
             * @methodOf lbServices.InstitutionSettings
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionSettings` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.InstitutionSettings#updateOrCreate
             * @methodOf lbServices.InstitutionSettings
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionSettings` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.InstitutionSettings#patchOrCreateWithWhere
             * @methodOf lbServices.InstitutionSettings
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionSettings` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.InstitutionSettings#update
             * @methodOf lbServices.InstitutionSettings
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.InstitutionSettings#destroyById
             * @methodOf lbServices.InstitutionSettings
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionSettings` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.InstitutionSettings#removeById
             * @methodOf lbServices.InstitutionSettings
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionSettings` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.InstitutionSettings#patchAttributes
             * @methodOf lbServices.InstitutionSettings
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institutionSettings id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionSettings` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.InstitutionSettings#modelName
        * @propertyOf lbServices.InstitutionSettings
        * @description
        * The name of the model represented by this $resource,
        * i.e. `InstitutionSettings`.
        */
        R.modelName = "InstitutionSettings";


            /**
             * @ngdoc method
             * @name lbServices.InstitutionSettings#institution
             * @methodOf lbServices.InstitutionSettings
             *
             * @description
             *
             * Fetches belongsTo relation institution.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institutionSettings id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
        R.institution = function() {
          var TargetResource = $injector.get("Institution");
          var action = TargetResource["::get::InstitutionSettings::institution"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.InstitutionAccess
 * @header lbServices.InstitutionAccess
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `InstitutionAccess` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "InstitutionAccess",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/institutionAccesses/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use InstitutionAccess.institution() instead.
            "prototype$__get__institution": {
              url: urlBase + "/institutionAccesses/:id/institution",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionAccess#create
             * @methodOf lbServices.InstitutionAccess
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionAccess` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/institutionAccesses",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionAccess#createMany
             * @methodOf lbServices.InstitutionAccess
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionAccess` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/institutionAccesses",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionAccess#upsert
             * @methodOf lbServices.InstitutionAccess
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionAccess` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/institutionAccesses",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionAccess#replaceOrCreate
             * @methodOf lbServices.InstitutionAccess
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionAccess` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/institutionAccesses/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionAccess#upsertWithWhere
             * @methodOf lbServices.InstitutionAccess
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionAccess` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/institutionAccesses/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionAccess#exists
             * @methodOf lbServices.InstitutionAccess
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/institutionAccesses/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionAccess#findById
             * @methodOf lbServices.InstitutionAccess
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionAccess` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/institutionAccesses/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionAccess#replaceById
             * @methodOf lbServices.InstitutionAccess
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionAccess` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/institutionAccesses/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionAccess#find
             * @methodOf lbServices.InstitutionAccess
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionAccess` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/institutionAccesses",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionAccess#findOne
             * @methodOf lbServices.InstitutionAccess
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionAccess` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/institutionAccesses/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionAccess#updateAll
             * @methodOf lbServices.InstitutionAccess
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/institutionAccesses/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionAccess#deleteById
             * @methodOf lbServices.InstitutionAccess
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionAccess` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/institutionAccesses/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionAccess#count
             * @methodOf lbServices.InstitutionAccess
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/institutionAccesses/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionAccess#prototype$updateAttributes
             * @methodOf lbServices.InstitutionAccess
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institutionAccess id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionAccess` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/institutionAccesses/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionAccess#createChangeStream
             * @methodOf lbServices.InstitutionAccess
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/institutionAccesses/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Institution.institutionAccess() instead.
            "::get::Institution::institutionAccess": {
              url: urlBase + "/institutions/:id/institutionAccess",
              method: "GET",
            },

            // INTERNAL. Use Institution.institutionAccess.create() instead.
            "::create::Institution::institutionAccess": {
              url: urlBase + "/institutions/:id/institutionAccess",
              method: "POST",
            },

            // INTERNAL. Use Institution.institutionAccess.createMany() instead.
            "::createMany::Institution::institutionAccess": {
              isArray: true,
              url: urlBase + "/institutions/:id/institutionAccess",
              method: "POST",
            },

            // INTERNAL. Use Institution.institutionAccess.update() instead.
            "::update::Institution::institutionAccess": {
              url: urlBase + "/institutions/:id/institutionAccess",
              method: "PUT",
            },

            // INTERNAL. Use Institution.institutionAccess.destroy() instead.
            "::destroy::Institution::institutionAccess": {
              url: urlBase + "/institutions/:id/institutionAccess",
              method: "DELETE",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.InstitutionAccess#patchOrCreate
             * @methodOf lbServices.InstitutionAccess
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionAccess` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.InstitutionAccess#updateOrCreate
             * @methodOf lbServices.InstitutionAccess
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionAccess` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.InstitutionAccess#patchOrCreateWithWhere
             * @methodOf lbServices.InstitutionAccess
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionAccess` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.InstitutionAccess#update
             * @methodOf lbServices.InstitutionAccess
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.InstitutionAccess#destroyById
             * @methodOf lbServices.InstitutionAccess
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionAccess` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.InstitutionAccess#removeById
             * @methodOf lbServices.InstitutionAccess
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionAccess` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.InstitutionAccess#patchAttributes
             * @methodOf lbServices.InstitutionAccess
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institutionAccess id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionAccess` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.InstitutionAccess#modelName
        * @propertyOf lbServices.InstitutionAccess
        * @description
        * The name of the model represented by this $resource,
        * i.e. `InstitutionAccess`.
        */
        R.modelName = "InstitutionAccess";


            /**
             * @ngdoc method
             * @name lbServices.InstitutionAccess#institution
             * @methodOf lbServices.InstitutionAccess
             *
             * @description
             *
             * Fetches belongsTo relation institution.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institutionAccess id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
        R.institution = function() {
          var TargetResource = $injector.get("Institution");
          var action = TargetResource["::get::InstitutionAccess::institution"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.BlockedIp
 * @header lbServices.BlockedIp
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `BlockedIp` model.
 *
 * **Details**
 *
 * Database table to store user's IP failure credit card attempts
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "BlockedIp",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/blockedIps/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.BlockedIp#create
             * @methodOf lbServices.BlockedIp
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIp` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/blockedIps",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BlockedIp#createMany
             * @methodOf lbServices.BlockedIp
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIp` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/blockedIps",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BlockedIp#upsert
             * @methodOf lbServices.BlockedIp
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIp` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/blockedIps",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.BlockedIp#replaceOrCreate
             * @methodOf lbServices.BlockedIp
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIp` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/blockedIps/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BlockedIp#upsertWithWhere
             * @methodOf lbServices.BlockedIp
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIp` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/blockedIps/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BlockedIp#exists
             * @methodOf lbServices.BlockedIp
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/blockedIps/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BlockedIp#findById
             * @methodOf lbServices.BlockedIp
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIp` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/blockedIps/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BlockedIp#replaceById
             * @methodOf lbServices.BlockedIp
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIp` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/blockedIps/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BlockedIp#find
             * @methodOf lbServices.BlockedIp
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIp` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/blockedIps",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BlockedIp#deleteById
             * @methodOf lbServices.BlockedIp
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIp` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/blockedIps/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.BlockedIp#count
             * @methodOf lbServices.BlockedIp
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/blockedIps/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BlockedIp#createChangeStream
             * @methodOf lbServices.BlockedIp
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/blockedIps/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BlockedIp#paymentAttempt
             * @methodOf lbServices.BlockedIp
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `failure` – `{boolean=}` -
             *
             *  - `userId` – `{number=}` -
             *
             *  - `roomSlug` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "paymentAttempt": {
              url: urlBase + "/blockedIps/paymentAttempt",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.BlockedIp#patchOrCreate
             * @methodOf lbServices.BlockedIp
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIp` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.BlockedIp#updateOrCreate
             * @methodOf lbServices.BlockedIp
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIp` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.BlockedIp#patchOrCreateWithWhere
             * @methodOf lbServices.BlockedIp
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIp` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.BlockedIp#destroyById
             * @methodOf lbServices.BlockedIp
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIp` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.BlockedIp#removeById
             * @methodOf lbServices.BlockedIp
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIp` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];


        /**
        * @ngdoc property
        * @name lbServices.BlockedIp#modelName
        * @propertyOf lbServices.BlockedIp
        * @description
        * The name of the model represented by this $resource,
        * i.e. `BlockedIp`.
        */
        R.modelName = "BlockedIp";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.BlockedIpEvents
 * @header lbServices.BlockedIpEvents
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `BlockedIpEvents` model.
 *
 * **Details**
 *
 * Database table to store payment attempts to see if we need to block them
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "BlockedIpEvents",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/blockedIpEvents/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.BlockedIpEvents#create
             * @methodOf lbServices.BlockedIpEvents
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIpEvents` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/blockedIpEvents",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BlockedIpEvents#createMany
             * @methodOf lbServices.BlockedIpEvents
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIpEvents` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/blockedIpEvents",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BlockedIpEvents#upsert
             * @methodOf lbServices.BlockedIpEvents
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIpEvents` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/blockedIpEvents",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.BlockedIpEvents#replaceOrCreate
             * @methodOf lbServices.BlockedIpEvents
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIpEvents` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/blockedIpEvents/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BlockedIpEvents#upsertWithWhere
             * @methodOf lbServices.BlockedIpEvents
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIpEvents` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/blockedIpEvents/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BlockedIpEvents#exists
             * @methodOf lbServices.BlockedIpEvents
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/blockedIpEvents/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BlockedIpEvents#findById
             * @methodOf lbServices.BlockedIpEvents
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIpEvents` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/blockedIpEvents/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BlockedIpEvents#replaceById
             * @methodOf lbServices.BlockedIpEvents
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIpEvents` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/blockedIpEvents/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BlockedIpEvents#deleteById
             * @methodOf lbServices.BlockedIpEvents
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIpEvents` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/blockedIpEvents/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.BlockedIpEvents#count
             * @methodOf lbServices.BlockedIpEvents
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/blockedIpEvents/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BlockedIpEvents#createChangeStream
             * @methodOf lbServices.BlockedIpEvents
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/blockedIpEvents/change-stream",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.BlockedIpEvents#patchOrCreate
             * @methodOf lbServices.BlockedIpEvents
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIpEvents` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.BlockedIpEvents#updateOrCreate
             * @methodOf lbServices.BlockedIpEvents
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIpEvents` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.BlockedIpEvents#patchOrCreateWithWhere
             * @methodOf lbServices.BlockedIpEvents
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIpEvents` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.BlockedIpEvents#destroyById
             * @methodOf lbServices.BlockedIpEvents
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIpEvents` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.BlockedIpEvents#removeById
             * @methodOf lbServices.BlockedIpEvents
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BlockedIpEvents` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];


        /**
        * @ngdoc property
        * @name lbServices.BlockedIpEvents#modelName
        * @propertyOf lbServices.BlockedIpEvents
        * @description
        * The name of the model represented by this $resource,
        * i.e. `BlockedIpEvents`.
        */
        R.modelName = "BlockedIpEvents";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.CallRating
 * @header lbServices.CallRating
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `CallRating` model.
 *
 * **Details**
 *
 * Database table to store ratings from after call survey
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "CallRating",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/callRatings/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.CallRating#create
             * @methodOf lbServices.CallRating
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallRating` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/callRatings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallRating#createMany
             * @methodOf lbServices.CallRating
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallRating` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/callRatings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallRating#upsert
             * @methodOf lbServices.CallRating
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallRating` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/callRatings",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallRating#replaceOrCreate
             * @methodOf lbServices.CallRating
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallRating` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/callRatings/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallRating#upsertWithWhere
             * @methodOf lbServices.CallRating
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallRating` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/callRatings/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallRating#exists
             * @methodOf lbServices.CallRating
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/callRatings/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallRating#findById
             * @methodOf lbServices.CallRating
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallRating` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/callRatings/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallRating#replaceById
             * @methodOf lbServices.CallRating
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallRating` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/callRatings/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallRating#find
             * @methodOf lbServices.CallRating
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallRating` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/callRatings",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallRating#findOne
             * @methodOf lbServices.CallRating
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallRating` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/callRatings/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallRating#updateAll
             * @methodOf lbServices.CallRating
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/callRatings/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallRating#deleteById
             * @methodOf lbServices.CallRating
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallRating` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/callRatings/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallRating#count
             * @methodOf lbServices.CallRating
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/callRatings/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallRating#prototype$updateAttributes
             * @methodOf lbServices.CallRating
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - callRating id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallRating` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/callRatings/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallRating#createChangeStream
             * @methodOf lbServices.CallRating
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/callRatings/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CallRating#save
             * @methodOf lbServices.CallRating
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `sessionId` – `{string=}` -
             *
             *  - `rating` – `{number=}` -
             *
             *  - `data` – `{*=}` -
             *
             *  - `comment` – `{string=}` -
             *
             *  - `noSoundDetected` – `{boolean=}` -
             *
             *  - `isProviderFeedback` – `{boolean=}` -
             *
             *  - `surveyType` – `{string=}` -
             *
             *  - `vendor` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallRating` object.)
             * </em>
             */
            "save": {
              url: urlBase + "/callRatings/save",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.CallRating#patchOrCreate
             * @methodOf lbServices.CallRating
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallRating` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CallRating#updateOrCreate
             * @methodOf lbServices.CallRating
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallRating` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CallRating#patchOrCreateWithWhere
             * @methodOf lbServices.CallRating
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallRating` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.CallRating#update
             * @methodOf lbServices.CallRating
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.CallRating#destroyById
             * @methodOf lbServices.CallRating
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallRating` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CallRating#removeById
             * @methodOf lbServices.CallRating
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallRating` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CallRating#patchAttributes
             * @methodOf lbServices.CallRating
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - callRating id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CallRating` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.CallRating#modelName
        * @propertyOf lbServices.CallRating
        * @description
        * The name of the model represented by this $resource,
        * i.e. `CallRating`.
        */
        R.modelName = "CallRating";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Stripe
 * @header lbServices.Stripe
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Stripe` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Stripe",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/stripe/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Stripe#createSubscriptionAtSignup
             * @methodOf lbServices.Stripe
             *
             * @description
             *
             * Creates a subscription from the sign-up flow
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` -
             *
             *  - `planId` – `{string}` -
             *
             *  - `countryCode` – `{string=}` -
             *
             *  - `postalCode` – `{string=}` -
             *
             *  - `idempotencyKey` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Stripe` object.)
             * </em>
             */
            "createSubscriptionAtSignup": {
              url: urlBase + "/stripe/subscription-create",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Stripe#createUserAccount
             * @methodOf lbServices.Stripe
             *
             * @description
             *
             * Creates a User in Stripe
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{}` -
             *
             *  - `userData` – `{object}` -
             *
             *  - `customer` – `{object}` -
             *
             *  - `subscription` – `{object}` -
             *
             *  - `paymentMethod` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Stripe` object.)
             * </em>
             */
            "createUserAccount": {
              url: urlBase + "/stripe/user-account-create",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Stripe#deleteCustomer
             * @methodOf lbServices.Stripe
             *
             * @description
             *
             * Deletes a user from Stripe
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `customerId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Stripe` object.)
             * </em>
             */
            "deleteCustomer": {
              url: urlBase + "/stripe/customer-delete",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Stripe#getProductByName
             * @methodOf lbServices.Stripe
             *
             * @description
             *
             * Gets a Stripe Product by name
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `productName` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Stripe` object.)
             * </em>
             */
            "getProductByName": {
              url: urlBase + "/stripe/products/:productName",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Stripe#getSource
             * @methodOf lbServices.Stripe
             *
             * @description
             *
             * Gets a Stripe customer's payment source by ID
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `customerId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Stripe` object.)
             * </em>
             */
            "getSource": {
              url: urlBase + "/stripe/get-source/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Stripe#getPlanById
             * @methodOf lbServices.Stripe
             *
             * @description
             *
             * Gets a Plan from Stripe by the ID
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Stripe` object.)
             * </em>
             */
            "getPlanById": {
              url: urlBase + "/stripe/get-plans/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Stripe#getProductById
             * @methodOf lbServices.Stripe
             *
             * @description
             *
             * Gets a Product from Stripe by the ID
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Stripe` object.)
             * </em>
             */
            "getProductById": {
              url: urlBase + "/stripe/get-products/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Stripe#getAllSupportedCurrencies
             * @methodOf lbServices.Stripe
             *
             * @description
             *
             * Gets all currencies configured in Stripe right now
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Stripe` object.)
             * </em>
             */
            "getAllSupportedCurrencies": {
              isArray: true,
              url: urlBase + "/stripe/currencies",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Stripe#getAllPlans
             * @methodOf lbServices.Stripe
             *
             * @description
             *
             * Gets all Stripe Plans
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Stripe` object.)
             * </em>
             */
            "getAllPlans": {
              isArray: true,
              url: urlBase + "/stripe/plans",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Stripe#getLatestInvoiceForCustomer
             * @methodOf lbServices.Stripe
             *
             * @description
             *
             * Gets the latest Invoice from Stripe for a Customer
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `customerId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Stripe` object.)
             * </em>
             */
            "getLatestInvoiceForCustomer": {
              url: urlBase + "/stripe/get-latest-invoice-for-customer",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Stripe#updateCustomerCountryAndZip
             * @methodOf lbServices.Stripe
             *
             * @description
             *
             * Updates a customer's country code and postal code in Stripe
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `customerId` – `{string}` -
             *
             *  - `email` – `{string}` -
             *
             *  - `planId` – `{string}` -
             *
             *  - `options` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Stripe` object.)
             * </em>
             */
            "updateCustomerCountryAndZip": {
              url: urlBase + "/stripe/update-customer-country-zip",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Stripe#getUpcomingInvoiceForCustomer
             * @methodOf lbServices.Stripe
             *
             * @description
             *
             * Gets an upcoming Invoice from Stripe for a Customer
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `customerId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Stripe` object.)
             * </em>
             */
            "getUpcomingInvoiceForCustomer": {
              url: urlBase + "/stripe/get-upcoming-invoice-for-customer",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Stripe#getCustomersByEmail
             * @methodOf lbServices.Stripe
             *
             * @description
             *
             * Finds a Customer in Stripe by the email
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Stripe` object.)
             * </em>
             */
            "getCustomersByEmail": {
              isArray: true,
              url: urlBase + "/stripe/get-customer-by-email",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Stripe#getSubscriptionById
             * @methodOf lbServices.Stripe
             *
             * @description
             *
             * Gets a Subscription from Stripe by the ID
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `subscriptionId` – `{string}` -
             *
             *  - `customerId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Stripe` object.)
             * </em>
             */
            "getSubscriptionById": {
              url: urlBase + "/stripe/get-subscription",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Stripe#getCouponById
             * @methodOf lbServices.Stripe
             *
             * @description
             *
             * Gets a Coupon from Stripe by the ID
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Stripe` object.)
             * </em>
             */
            "getCouponById": {
              url: urlBase + "/stripe/get-coupons/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Stripe#redirectToCustomerPortal
             * @methodOf lbServices.Stripe
             *
             * @description
             *
             * Redirects to the Customer Billing Portal in Stripe
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Stripe` object.)
             * </em>
             */
            "redirectToCustomerPortal": {
              url: urlBase + "/stripe/customer-portal",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Stripe#getTaxAmount
             * @methodOf lbServices.Stripe
             *
             * @description
             *
             * Get Tax amount from Stripe
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` -
             *
             *  - `planId` – `{string}` -
             *
             *  - `postalCode` – `{string}` -
             *
             *  - `countryCode` – `{string}` -
             *
             *  - `seats` – `{number=}` -
             *
             *  - `coupon` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Stripe` object.)
             * </em>
             */
            "getTaxAmount": {
              url: urlBase + "/stripe/get-tax",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Stripe#getCustomerPaymentMethodById
             * @methodOf lbServices.Stripe
             *
             * @description
             *
             * Get Customer Payment Method by ID
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `customerId` – `{string}` -
             *
             *  - `paymentMethodId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Stripe` object.)
             * </em>
             */
            "getCustomerPaymentMethodById": {
              url: urlBase + "/stripe/get-customer-payment-method",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Stripe#modelName
        * @propertyOf lbServices.Stripe
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Stripe`.
        */
        R.modelName = "Stripe";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.DokbotWorkflow
 * @header lbServices.DokbotWorkflow
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `DokbotWorkflow` model.
 *
 * **Details**
 *
 * Database table to store workflows used by dokbot
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "DokbotWorkflow",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/dokbotWorkflow/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use DokbotWorkflow.institution() instead.
            "prototype$__get__institution": {
              url: urlBase + "/dokbotWorkflow/:id/institution",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.DokbotWorkflow#getWorkflow
             * @methodOf lbServices.DokbotWorkflow
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `userId` – `{number=}` -
             *
             *  - `institutionId` – `{number=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DokbotWorkflow` object.)
             * </em>
             */
            "getWorkflow": {
              url: urlBase + "/dokbotWorkflow/getWorkflow",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.DokbotWorkflow#updateWorkflow
             * @methodOf lbServices.DokbotWorkflow
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DokbotWorkflow` object.)
             * </em>
             */
            "updateWorkflow": {
              url: urlBase + "/dokbotWorkflow/updateWorkflow",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.DokbotWorkflow#modelName
        * @propertyOf lbServices.DokbotWorkflow
        * @description
        * The name of the model represented by this $resource,
        * i.e. `DokbotWorkflow`.
        */
        R.modelName = "DokbotWorkflow";


            /**
             * @ngdoc method
             * @name lbServices.DokbotWorkflow#institution
             * @methodOf lbServices.DokbotWorkflow
             *
             * @description
             *
             * Fetches belongsTo relation institution.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - dokbotWorkflow id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
        R.institution = function() {
          var TargetResource = $injector.get("Institution");
          var action = TargetResource["::get::DokbotWorkflow::institution"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.InstitutionLocation
 * @header lbServices.InstitutionLocation
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `InstitutionLocation` model.
 *
 * **Details**
 *
 * Database table to store institution locations
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "InstitutionLocation",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/institutionLocation/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use InstitutionLocation.institution() instead.
            "prototype$__get__institution": {
              url: urlBase + "/institutionLocation/:id/institution",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionLocation#getLocations
             * @methodOf lbServices.InstitutionLocation
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `institutionId` – `{number}` -
             *
             *  - `sortBy` – `{string=}` -
             *
             *  - `isDesc` – `{boolean=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionLocation` object.)
             * </em>
             */
            "getLocations": {
              isArray: true,
              url: urlBase + "/institutionLocation",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionLocation#createLocation
             * @methodOf lbServices.InstitutionLocation
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `institutionId` – `{number}` -
             *
             *  - `name` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionLocation` object.)
             * </em>
             */
            "createLocation": {
              url: urlBase + "/institutionLocation",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionLocation#bulkUsersUpdate
             * @methodOf lbServices.InstitutionLocation
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `institutionId` – `{number}` -
             *
             *  - `userData` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InstitutionLocation` object.)
             * </em>
             */
            "bulkUsersUpdate": {
              url: urlBase + "/institutionLocation/bulkUsersUpdate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionLocation#prototype$updateLocation
             * @methodOf lbServices.InstitutionLocation
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institutionLocation id
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `name` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$updateLocation": {
              url: urlBase + "/institutionLocation/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InstitutionLocation#prototype$deleteLocation
             * @methodOf lbServices.InstitutionLocation
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institutionLocation id
             *
             *  - `ctx` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$deleteLocation": {
              url: urlBase + "/institutionLocation/:id",
              method: "DELETE",
            },

            // INTERNAL. Use InstitutionMember.institutionLocation() instead.
            "::get::InstitutionMember::institutionLocation": {
              url: urlBase + "/institutionMembers/:id/institutionLocation",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.InstitutionLocation#modelName
        * @propertyOf lbServices.InstitutionLocation
        * @description
        * The name of the model represented by this $resource,
        * i.e. `InstitutionLocation`.
        */
        R.modelName = "InstitutionLocation";


            /**
             * @ngdoc method
             * @name lbServices.InstitutionLocation#institution
             * @methodOf lbServices.InstitutionLocation
             *
             * @description
             *
             * Fetches belongsTo relation institution.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - institutionLocation id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
        R.institution = function() {
          var TargetResource = $injector.get("Institution");
          var action = TargetResource["::get::InstitutionLocation::institution"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.BannerUserAcknowledge
 * @header lbServices.BannerUserAcknowledge
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `BannerUserAcknowledge` model.
 *
 * **Details**
 *
 * API representation of user banners acknowledgement
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "BannerUserAcknowledge",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/banner-user-acknowledge/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.BannerUserAcknowledge#getUnseen
             * @methodOf lbServices.BannerUserAcknowledge
             *
             * @description
             *
             * Returns unseen banner steps for the current user
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BannerUserAcknowledge` object.)
             * </em>
             */
            "getUnseen": {
              url: urlBase + "/banner-user-acknowledge/get-unseen",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BannerUserAcknowledge#acknowledge
             * @methodOf lbServices.BannerUserAcknowledge
             *
             * @description
             *
             * Add banner step to user acknowledge
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `bannerName` – `{string}` -
             *
             *  - `bannerStepName` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BannerUserAcknowledge` object.)
             * </em>
             */
            "acknowledge": {
              url: urlBase + "/banner-user-acknowledge/acknowledge",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.BannerUserAcknowledge#modelName
        * @propertyOf lbServices.BannerUserAcknowledge
        * @description
        * The name of the model represented by this $resource,
        * i.e. `BannerUserAcknowledge`.
        */
        R.modelName = "BannerUserAcknowledge";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.SsoService
 * @header lbServices.SsoService
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `SsoService` model.
 *
 * **Details**
 *
 * Keeps info about SSO service providers
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "SsoService",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/sso/services/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.SsoService#create
             * @methodOf lbServices.SsoService
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SsoService` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/sso/services",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SsoService#createMany
             * @methodOf lbServices.SsoService
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SsoService` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/sso/services",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SsoService#findById
             * @methodOf lbServices.SsoService
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SsoService` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/sso/services/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SsoService#find
             * @methodOf lbServices.SsoService
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SsoService` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/sso/services",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SsoService#deleteById
             * @methodOf lbServices.SsoService
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SsoService` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/sso/services/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SsoService#prototype$updateAttributes
             * @methodOf lbServices.SsoService
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ssoService id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SsoService` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/sso/services/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.SsoService#getRedirectUrl
             * @methodOf lbServices.SsoService
             *
             * @description
             *
             * Generates sso redirectUrl for service providers
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{}` -
             *
             *  - `spName` – `{string}` -
             *
             *  - `institutionId` – `{number=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `url` – `{string=}` -
             */
            "getRedirectUrl": {
              url: urlBase + "/sso/services/get-redirect-url",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.SsoService#destroyById
             * @methodOf lbServices.SsoService
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SsoService` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SsoService#removeById
             * @methodOf lbServices.SsoService
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SsoService` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SsoService#patchAttributes
             * @methodOf lbServices.SsoService
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ssoService id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SsoService` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.SsoService#modelName
        * @propertyOf lbServices.SsoService
        * @description
        * The name of the model represented by this $resource,
        * i.e. `SsoService`.
        */
        R.modelName = "SsoService";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.UserManageableFeature
 * @header lbServices.UserManageableFeature
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `UserManageableFeature` model.
 *
 * **Details**
 *
 * Database table to store features turned on/off for a user
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "UserManageableFeature",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/userManageableFeatures/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.UserManageableFeature#getFeatures
             * @methodOf lbServices.UserManageableFeature
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `userId` – `{number}` -
             *
             *  - `institutionId` – `{number=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserManageableFeature` object.)
             * </em>
             */
            "getFeatures": {
              isArray: true,
              url: urlBase + "/userManageableFeatures",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserManageableFeature#setFeatureValue
             * @methodOf lbServices.UserManageableFeature
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{undefined=}` -
             *
             *  - `featureKey` – `{string}` -
             *
             *  - `isEnabled` – `{boolean}` -
             *
             *  - `userId` – `{number}` -
             *
             *  - `institutionId` – `{number=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserManageableFeature` object.)
             * </em>
             */
            "setFeatureValue": {
              url: urlBase + "/userManageableFeatures/:featureKey",
              method: "PUT",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.UserManageableFeature#modelName
        * @propertyOf lbServices.UserManageableFeature
        * @description
        * The name of the model represented by this $resource,
        * i.e. `UserManageableFeature`.
        */
        R.modelName = "UserManageableFeature";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ActiveDocument
 * @header lbServices.ActiveDocument
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ActiveDocument` model.
 *
 * **Details**
 *
 * Database table to store document access
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ActiveDocument",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/activeDocuments/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ActiveDocument.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/activeDocuments/:id/user",
              method: "GET",
            },

            // INTERNAL. Use ActiveDocument.teleconsentDocument() instead.
            "prototype$__get__teleconsentDocument": {
              url: urlBase + "/activeDocuments/:id/teleconsentDocument",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ActiveDocument#getAvailable
             * @methodOf lbServices.ActiveDocument
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `institutionId` – `{number=}` -
             *
             *  - `includeDefaultForInstitution` – `{boolean=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ActiveDocument` object.)
             * </em>
             */
            "getAvailable": {
              isArray: true,
              url: urlBase + "/activeDocuments/getAvailable",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ActiveDocument#toggleForProvider
             * @methodOf lbServices.ActiveDocument
             *
             * @description
             *
             * Create or update active document for individuals
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `institutionId` – `{number}` -
             *
             *  - `teleconsentDocumentId` – `{number}` -
             *
             *  - `isActive` – `{boolean}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ActiveDocument` object.)
             * </em>
             */
            "toggleForProvider": {
              url: urlBase + "/activeDocuments/toggleForProvider",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ActiveDocument#toggleForClinic
             * @methodOf lbServices.ActiveDocument
             *
             * @description
             *
             * Create or update active document record for clinic
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `institutionId` – `{number}` -
             *
             *  - `teleconsentDocumentId` – `{number}` -
             *
             *  - `isActive` – `{boolean}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ActiveDocument` object.)
             * </em>
             */
            "toggleForClinic": {
              url: urlBase + "/activeDocuments/toggleForClinic",
              method: "POST",
            },

            // INTERNAL. Use TeleconsentDocument.activeDocument.findById() instead.
            "::findById::TeleconsentDocument::activeDocument": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/teleconsentDocuments/:id/activeDocument/:fk",
              method: "GET",
            },

            // INTERNAL. Use TeleconsentDocument.activeDocument.destroyById() instead.
            "::destroyById::TeleconsentDocument::activeDocument": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/teleconsentDocuments/:id/activeDocument/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use TeleconsentDocument.activeDocument.updateById() instead.
            "::updateById::TeleconsentDocument::activeDocument": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/teleconsentDocuments/:id/activeDocument/:fk",
              method: "PUT",
            },

            // INTERNAL. Use TeleconsentDocument.activeDocument() instead.
            "::get::TeleconsentDocument::activeDocument": {
              isArray: true,
              url: urlBase + "/teleconsentDocuments/:id/activeDocument",
              method: "GET",
            },

            // INTERNAL. Use TeleconsentDocument.activeDocument.create() instead.
            "::create::TeleconsentDocument::activeDocument": {
              url: urlBase + "/teleconsentDocuments/:id/activeDocument",
              method: "POST",
            },

            // INTERNAL. Use TeleconsentDocument.activeDocument.createMany() instead.
            "::createMany::TeleconsentDocument::activeDocument": {
              isArray: true,
              url: urlBase + "/teleconsentDocuments/:id/activeDocument",
              method: "POST",
            },

            // INTERNAL. Use TeleconsentDocument.activeDocument.destroyAll() instead.
            "::delete::TeleconsentDocument::activeDocument": {
              url: urlBase + "/teleconsentDocuments/:id/activeDocument",
              method: "DELETE",
            },

            // INTERNAL. Use TeleconsentDocument.activeDocument.count() instead.
            "::count::TeleconsentDocument::activeDocument": {
              url: urlBase + "/teleconsentDocuments/:id/activeDocument/count",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.ActiveDocument#modelName
        * @propertyOf lbServices.ActiveDocument
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ActiveDocument`.
        */
        R.modelName = "ActiveDocument";


            /**
             * @ngdoc method
             * @name lbServices.ActiveDocument#user
             * @methodOf lbServices.ActiveDocument
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - activeDocument id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::ActiveDocument::user"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ActiveDocument#teleconsentDocument
             * @methodOf lbServices.ActiveDocument
             *
             * @description
             *
             * Fetches belongsTo relation teleconsentDocument.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - activeDocument id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TeleconsentDocument` object.)
             * </em>
             */
        R.teleconsentDocument = function() {
          var TargetResource = $injector.get("TeleconsentDocument");
          var action = TargetResource["::get::ActiveDocument::teleconsentDocument"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TeleconsentDocument
 * @header lbServices.TeleconsentDocument
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TeleconsentDocument` model.
 *
 * **Details**
 *
 * Database table to store teleconsent documents
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TeleconsentDocument",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/teleconsentDocuments/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use TeleconsentDocument.institution() instead.
            "prototype$__get__institution": {
              url: urlBase + "/teleconsentDocuments/:id/institution",
              method: "GET",
            },

            // INTERNAL. Use TeleconsentDocument.document() instead.
            "prototype$__get__document": {
              url: urlBase + "/teleconsentDocuments/:id/document",
              method: "GET",
            },

            // INTERNAL. Use TeleconsentDocument.activeDocument.findById() instead.
            "prototype$__findById__activeDocument": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/teleconsentDocuments/:id/activeDocument/:fk",
              method: "GET",
            },

            // INTERNAL. Use TeleconsentDocument.activeDocument.destroyById() instead.
            "prototype$__destroyById__activeDocument": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/teleconsentDocuments/:id/activeDocument/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use TeleconsentDocument.activeDocument.updateById() instead.
            "prototype$__updateById__activeDocument": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/teleconsentDocuments/:id/activeDocument/:fk",
              method: "PUT",
            },

            // INTERNAL. Use TeleconsentDocument.activeDocument() instead.
            "prototype$__get__activeDocument": {
              isArray: true,
              url: urlBase + "/teleconsentDocuments/:id/activeDocument",
              method: "GET",
            },

            // INTERNAL. Use TeleconsentDocument.activeDocument.create() instead.
            "prototype$__create__activeDocument": {
              url: urlBase + "/teleconsentDocuments/:id/activeDocument",
              method: "POST",
            },

            // INTERNAL. Use TeleconsentDocument.activeDocument.destroyAll() instead.
            "prototype$__delete__activeDocument": {
              url: urlBase + "/teleconsentDocuments/:id/activeDocument",
              method: "DELETE",
            },

            // INTERNAL. Use TeleconsentDocument.activeDocument.count() instead.
            "prototype$__count__activeDocument": {
              url: urlBase + "/teleconsentDocuments/:id/activeDocument/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TeleconsentDocument#create
             * @methodOf lbServices.TeleconsentDocument
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TeleconsentDocument` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/teleconsentDocuments",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TeleconsentDocument#createMany
             * @methodOf lbServices.TeleconsentDocument
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TeleconsentDocument` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/teleconsentDocuments",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TeleconsentDocument#findById
             * @methodOf lbServices.TeleconsentDocument
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TeleconsentDocument` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/teleconsentDocuments/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TeleconsentDocument#deleteById
             * @methodOf lbServices.TeleconsentDocument
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TeleconsentDocument` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/teleconsentDocuments/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TeleconsentDocument#prototype$updateAttributes
             * @methodOf lbServices.TeleconsentDocument
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - teleconsentDocument id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TeleconsentDocument` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/teleconsentDocuments/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TeleconsentDocument#getDefaults
             * @methodOf lbServices.TeleconsentDocument
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TeleconsentDocument` object.)
             * </em>
             */
            "getDefaults": {
              isArray: true,
              url: urlBase + "/teleconsentDocuments/getDefaults",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TeleconsentDocument#getForInstitution
             * @methodOf lbServices.TeleconsentDocument
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `institutionId` – `{number}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TeleconsentDocument` object.)
             * </em>
             */
            "getForInstitution": {
              isArray: true,
              url: urlBase + "/teleconsentDocuments/getForInstitution",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TeleconsentDocument#getByDocumentId
             * @methodOf lbServices.TeleconsentDocument
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `documentId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TeleconsentDocument` object.)
             * </em>
             */
            "getByDocumentId": {
              url: urlBase + "/teleconsentDocuments/getByDocumentId",
              method: "POST",
            },

            // INTERNAL. Use ActiveDocument.teleconsentDocument() instead.
            "::get::ActiveDocument::teleconsentDocument": {
              url: urlBase + "/activeDocuments/:id/teleconsentDocument",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.TeleconsentDocument#destroyById
             * @methodOf lbServices.TeleconsentDocument
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TeleconsentDocument` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TeleconsentDocument#removeById
             * @methodOf lbServices.TeleconsentDocument
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TeleconsentDocument` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TeleconsentDocument#patchAttributes
             * @methodOf lbServices.TeleconsentDocument
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - teleconsentDocument id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TeleconsentDocument` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.TeleconsentDocument#modelName
        * @propertyOf lbServices.TeleconsentDocument
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TeleconsentDocument`.
        */
        R.modelName = "TeleconsentDocument";


            /**
             * @ngdoc method
             * @name lbServices.TeleconsentDocument#institution
             * @methodOf lbServices.TeleconsentDocument
             *
             * @description
             *
             * Fetches belongsTo relation institution.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - teleconsentDocument id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Institution` object.)
             * </em>
             */
        R.institution = function() {
          var TargetResource = $injector.get("Institution");
          var action = TargetResource["::get::TeleconsentDocument::institution"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TeleconsentDocument#document
             * @methodOf lbServices.TeleconsentDocument
             *
             * @description
             *
             * Fetches belongsTo relation document.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - teleconsentDocument id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Document` object.)
             * </em>
             */
        R.document = function() {
          var TargetResource = $injector.get("Document");
          var action = TargetResource["::get::TeleconsentDocument::document"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.TeleconsentDocument.activeDocument
     * @header lbServices.TeleconsentDocument.activeDocument
     * @object
     * @description
     *
     * The object `TeleconsentDocument.activeDocument` groups methods
     * manipulating `ActiveDocument` instances related to `TeleconsentDocument`.
     *
     * Call {@link lbServices.TeleconsentDocument#activeDocument TeleconsentDocument.activeDocument()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.TeleconsentDocument#activeDocument
             * @methodOf lbServices.TeleconsentDocument
             *
             * @description
             *
             * Queries activeDocument of teleconsentDocument.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - teleconsentDocument id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ActiveDocument` object.)
             * </em>
             */
        R.activeDocument = function() {
          var TargetResource = $injector.get("ActiveDocument");
          var action = TargetResource["::get::TeleconsentDocument::activeDocument"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TeleconsentDocument.activeDocument#count
             * @methodOf lbServices.TeleconsentDocument.activeDocument
             *
             * @description
             *
             * Counts activeDocument of teleconsentDocument.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - teleconsentDocument id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.activeDocument.count = function() {
          var TargetResource = $injector.get("ActiveDocument");
          var action = TargetResource["::count::TeleconsentDocument::activeDocument"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TeleconsentDocument.activeDocument#create
             * @methodOf lbServices.TeleconsentDocument.activeDocument
             *
             * @description
             *
             * Creates a new instance in activeDocument of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - teleconsentDocument id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ActiveDocument` object.)
             * </em>
             */
        R.activeDocument.create = function() {
          var TargetResource = $injector.get("ActiveDocument");
          var action = TargetResource["::create::TeleconsentDocument::activeDocument"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TeleconsentDocument.activeDocument#createMany
             * @methodOf lbServices.TeleconsentDocument.activeDocument
             *
             * @description
             *
             * Creates a new instance in activeDocument of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - teleconsentDocument id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ActiveDocument` object.)
             * </em>
             */
        R.activeDocument.createMany = function() {
          var TargetResource = $injector.get("ActiveDocument");
          var action = TargetResource["::createMany::TeleconsentDocument::activeDocument"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TeleconsentDocument.activeDocument#destroyAll
             * @methodOf lbServices.TeleconsentDocument.activeDocument
             *
             * @description
             *
             * Deletes all activeDocument of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - teleconsentDocument id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.activeDocument.destroyAll = function() {
          var TargetResource = $injector.get("ActiveDocument");
          var action = TargetResource["::delete::TeleconsentDocument::activeDocument"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TeleconsentDocument.activeDocument#destroyById
             * @methodOf lbServices.TeleconsentDocument.activeDocument
             *
             * @description
             *
             * Delete a related item by id for activeDocument.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - teleconsentDocument id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for activeDocument
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.activeDocument.destroyById = function() {
          var TargetResource = $injector.get("ActiveDocument");
          var action = TargetResource["::destroyById::TeleconsentDocument::activeDocument"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TeleconsentDocument.activeDocument#findById
             * @methodOf lbServices.TeleconsentDocument.activeDocument
             *
             * @description
             *
             * Find a related item by id for activeDocument.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - teleconsentDocument id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for activeDocument
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ActiveDocument` object.)
             * </em>
             */
        R.activeDocument.findById = function() {
          var TargetResource = $injector.get("ActiveDocument");
          var action = TargetResource["::findById::TeleconsentDocument::activeDocument"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TeleconsentDocument.activeDocument#updateById
             * @methodOf lbServices.TeleconsentDocument.activeDocument
             *
             * @description
             *
             * Update a related item by id for activeDocument.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - teleconsentDocument id
             *
             *  - `fk` – `{*}` - Foreign key for activeDocument
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ActiveDocument` object.)
             * </em>
             */
        R.activeDocument.updateById = function() {
          var TargetResource = $injector.get("ActiveDocument");
          var action = TargetResource["::updateById::TeleconsentDocument::activeDocument"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.RateLimit
 * @header lbServices.RateLimit
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `RateLimit` model.
 *
 * **Details**
 *
 * Represents any part of functionality that could have an usage limit
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "RateLimit",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/rateLimits/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.RateLimit#create
             * @methodOf lbServices.RateLimit
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RateLimit` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/rateLimits",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RateLimit#createMany
             * @methodOf lbServices.RateLimit
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RateLimit` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/rateLimits",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RateLimit#find
             * @methodOf lbServices.RateLimit
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RateLimit` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/rateLimits",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RateLimit#deleteById
             * @methodOf lbServices.RateLimit
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RateLimit` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/rateLimits/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.RateLimit#prototype$updateAttributes
             * @methodOf lbServices.RateLimit
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RateLimit` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/rateLimits/:id",
              method: "PUT",
            },

            // INTERNAL. Use UserRateLimit.rateLimit() instead.
            "::get::UserRateLimit::rateLimit": {
              url: urlBase + "/userRateLimits/:id/rateLimit",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.RateLimit#destroyById
             * @methodOf lbServices.RateLimit
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RateLimit` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RateLimit#removeById
             * @methodOf lbServices.RateLimit
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RateLimit` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RateLimit#patchAttributes
             * @methodOf lbServices.RateLimit
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RateLimit` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.RateLimit#modelName
        * @propertyOf lbServices.RateLimit
        * @description
        * The name of the model represented by this $resource,
        * i.e. `RateLimit`.
        */
        R.modelName = "RateLimit";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.UserRateLimit
 * @header lbServices.UserRateLimit
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `UserRateLimit` model.
 *
 * **Details**
 *
 * Represents Many to Many relation between User and rateLimit models. To be able to customize limitation for a specific user.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "UserRateLimit",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/userRateLimits/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use UserRateLimit.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/userRateLimits/:id/user",
              method: "GET",
            },

            // INTERNAL. Use UserRateLimit.rateLimit() instead.
            "prototype$__get__rateLimit": {
              url: urlBase + "/userRateLimits/:id/rateLimit",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRateLimit#find
             * @methodOf lbServices.UserRateLimit
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRateLimit` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/userRateLimits",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRateLimit#setLimit
             * @methodOf lbServices.UserRateLimit
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `userId` – `{number}` -
             *
             *  - `rateLimitId` – `{number}` -
             *
             *  - `customQuota` – `{number=}` -
             *
             *  - `comment` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRateLimit` object.)
             * </em>
             */
            "setLimit": {
              url: urlBase + "/userRateLimits/setLimit",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRateLimit#resetLimit
             * @methodOf lbServices.UserRateLimit
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `userId` – `{number}` -
             *
             *  - `rateLimitId` – `{number=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "resetLimit": {
              url: urlBase + "/userRateLimits/resetLimit",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.UserRateLimit#modelName
        * @propertyOf lbServices.UserRateLimit
        * @description
        * The name of the model represented by this $resource,
        * i.e. `UserRateLimit`.
        */
        R.modelName = "UserRateLimit";


            /**
             * @ngdoc method
             * @name lbServices.UserRateLimit#user
             * @methodOf lbServices.UserRateLimit
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - userRateLimit id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::UserRateLimit::user"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.UserRateLimit#rateLimit
             * @methodOf lbServices.UserRateLimit
             *
             * @description
             *
             * Fetches belongsTo relation rateLimit.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - userRateLimit id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RateLimit` object.)
             * </em>
             */
        R.rateLimit = function() {
          var TargetResource = $injector.get("RateLimit");
          var action = TargetResource["::get::UserRateLimit::rateLimit"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Migration
 * @header lbServices.Migration
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Migration` model.
 *
 * **Details**
 *
 * View and run pending migrations.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Migration",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Migrations/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Migration#prototype$updateAttributes
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Migration id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Migration` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Migrations/:id",
              method: "PUT",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Migration#patchAttributes
             * @methodOf lbServices.Migration
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Migration id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Migration` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Migration#modelName
        * @propertyOf lbServices.Migration
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Migration`.
        */
        R.modelName = "Migration";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.MigrationMap
 * @header lbServices.MigrationMap
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `MigrationMap` model.
 *
 * **Details**
 *
 * Migration Mappings.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "MigrationMap",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/MigrationMaps/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#prototype$updateAttributes
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - MigrationMap id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `MigrationMap` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/MigrationMaps/:id",
              method: "PUT",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.MigrationMap#patchAttributes
             * @methodOf lbServices.MigrationMap
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - MigrationMap id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `MigrationMap` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.MigrationMap#modelName
        * @propertyOf lbServices.MigrationMap
        * @description
        * The name of the model represented by this $resource,
        * i.e. `MigrationMap`.
        */
        R.modelName = "MigrationMap";



        return R;
      }]);


  module
  .factory('LoopBackAuth', function() {
    var props = ['accessTokenId', 'currentUserId', 'rememberMe'];
    var propsPrefix = '$LoopBack$';

    function LoopBackAuth() {
      var self = this;
      props.forEach(function(name) {
        self[name] = load(name);
      });
      this.currentUserData = null;
    }

    LoopBackAuth.prototype.save = function() {
      var self = this;
      var storage = this.rememberMe ? localStorage : sessionStorage;
      props.forEach(function(name) {
        save(storage, name, self[name]);
      });
    };

    LoopBackAuth.prototype.setUser = function(accessTokenId, userId, userData) {
      this.accessTokenId = accessTokenId;
      this.currentUserId = userId;
      this.currentUserData = userData;
    };

    LoopBackAuth.prototype.clearUser = function() {
      this.accessTokenId = null;
      this.currentUserId = null;
      this.currentUserData = null;
    };

    LoopBackAuth.prototype.clearStorage = function() {
      props.forEach(function(name) {
        save(sessionStorage, name, null);
        save(localStorage, name, null);
      });
    };

    return new LoopBackAuth();

    // Note: LocalStorage converts the value to string
    // We are using empty string as a marker for null/undefined values.
    function save(storage, name, value) {
      try {
        var key = propsPrefix + name;
        if (value == null) value = '';
        storage[key] = value;
      } catch (err) {
        console.log('Cannot access local/session storage:', err);
      }
    }

    function load(name) {
      var key = propsPrefix + name;
      return localStorage[key] || sessionStorage[key] || null;
    }
  })
  .config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('LoopBackAuthRequestInterceptor');
  }])
  .factory('LoopBackAuthRequestInterceptor', ['$q', 'LoopBackAuth',
    function($q, LoopBackAuth) {
      return {
        'request': function(config) {
          // filter out external requests
          var host = getHost(config.url);
          if (host && host !== urlBaseHost) {
            return config;
          }

          if (LoopBackAuth.accessTokenId) {
            config.headers[authHeader] = LoopBackAuth.accessTokenId;
          } else if (config.__isGetCurrentUser__) {
            // Return a stub 401 error for User.getCurrent() when
            // there is no user logged in
            var res = {
              body: { error: { status: 401 }},
              status: 401,
              config: config,
              headers: function() { return undefined; },
            };
            return $q.reject(res);
          }
          return config || $q.when(config);
        },
      };
    }])

  /**
   * @ngdoc object
   * @name lbServices.LoopBackResourceProvider
   * @header lbServices.LoopBackResourceProvider
   * @description
   * Use `LoopBackResourceProvider` to change the global configuration
   * settings used by all models. Note that the provider is available
   * to Configuration Blocks only, see
   * {@link https://docs.angularjs.org/guide/module#module-loading-dependencies Module Loading & Dependencies}
   * for more details.
   *
   * ## Example
   *
   * ```js
   * angular.module('app')
   *  .config(function(LoopBackResourceProvider) {
   *     LoopBackResourceProvider.setAuthHeader('X-Access-Token');
   *  });
   * ```
   */
  .provider('LoopBackResource', function LoopBackResourceProvider() {
    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} header The header name to use, e.g. `X-Access-Token`
     * @description
     * Configure the REST transport to use a different header for sending
     * the authentication token. It is sent in the `Authorization` header
     * by default.
     */
    this.setAuthHeader = function(header) {
      authHeader = header;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the header name that is used for sending the authentication token.
     */
    this.getAuthHeader = function() {
      return authHeader;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} url The URL to use, e.g. `/api` or `//example.com/api`.
     * @description
     * Change the URL of the REST API server. By default, the URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.setUrlBase = function(url) {
      urlBase = url;
      urlBaseHost = getHost(urlBase) || location.host;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the URL of the REST API server. The URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.getUrlBase = function() {
      return urlBase;
    };

    this.$get = ['$resource', function($resource) {
      var LoopBackResource = function(url, params, actions) {
        var resource = $resource(url, params, actions);

        // Angular always calls POST on $save()
        // This hack is based on
        // http://kirkbushell.me/angular-js-using-ng-resource-in-a-more-restful-manner/
        resource.prototype.$save = function(success, error) {
          // Fortunately, LoopBack provides a convenient `upsert` method
          // that exactly fits our needs.
          var result = resource.upsert.call(this, {}, this, success, error);
          return result.$promise || result;
        };
        return resource;
      };

      LoopBackResource.getUrlBase = function() {
        return urlBase;
      };

      LoopBackResource.getAuthHeader = function() {
        return authHeader;
      };

      return LoopBackResource;
    }];
  });
})(window, window.angular);
